import home from './home';
import header from './header';

export default {
  homePage: home.en_US,
  headerNew: header.en_US,
  exchange: 'Exchange',
  // translate
  common: {
    reload: 'refresh',
    notData: 'No Data ',
    error_500: 'The server is busy, please try again later ',
    imgError: 'Image size is too large',
    imgFiail: 'Image upload failed',
    pageTitleText: 'Bitcoin trading platform',
    year: 'Year',
    mouth: 'Mouth',
    zhang: 'Cont',
    time: 'Date',
    email: 'Email address',
    phone: 'Phone number',
    search: ' Search',
    coin: 'Coin',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    date: ['S', 'M', 'T', 'W', 'S', 'F', 'S'],
  },
  // translate
  phoneCode: {
    A: [
      'Afghanistan +93+4',
      'Albania +355+8',
      'Algeria +213+12',
      'American Samoa +684+16',
      'Andorra +376+20',
      'Angola +244+24',
      'Anguilla +1264+660',
      'Antigua and Barbuda +1268+28',
      'Argentina +54+32',
      'Armenia +374+51',
      'Australia +61+36',
      'Austria +43+40',
      'Azerbaijan +994+31',
    ],
    B: [
      'Bahamas +1242+44',
      'Bahrain +973+48',
      'Bangladesh +880+50',
      'Barbados +1246+52',
      'Belarus +375+112',
      'Belgium +32+56',
      'Belize +501+84',
      'Benin +229+204',
      'Bermuda Islands +1441+60',
      'Bolivia +591+68',
      'Botswana +267+72',
      'Brazil +55+76',
      'Brunei +673+96',
      'Bulgaria +359+100',
      'Burkina Faso +226+854',
      'Burundi +257+108',
    ],
    C: [
      'Cambodia +855+116',
      'Cameroon +237+120',
      'Canada +1+124',
      'Cayman Islands +1345+136',
      'Central African Republic +236+140',
      'Chad +235+148',
      'Chile +56+152',
      // 'China +86+156',
      'Colombia +57+170',
      'Congo +242+178',
      'Cook Islands +682+184',
      'Costa Rica +506+188',
      "Côte d'Ivoire +225+384",
      'Cuba +53+192',
      'Cyprus +357+196',
      'Czech Republic +420+203',
    ],
    D: [
      'Denmark +45+208',
      'Djibouti +253+262',
      'Dominican Republic +1890+214',
    ],
    E: [
      'Ecuador +593+218',
      'Egypt +20+818',
      'El Salvador +503+222',
      'Estonia +372+233',
      'Ethiopia +251+231',
    ],
    F: [
      'Fiji Islands +679+242',
      'Finland +358+246',
      'France +33+250',
      'French Guiana +594+254',
      'French Polynesia +689+258',
    ],
    G: [
      'Gabon +241+266',
      'Gambia +220+270',
      'Georgia +995+268',
      'Germany +49+276',
      'Ghana +233+288',
      'Gibraltar +350+292',
      'Greece +30+300',
      'Grenada +1809+308',
      'Guam +1671+316',
      'Guatemala +502+320',
      'Guinea +224+324',
      'Guyana +592+328',
    ],
    H: [
      'Haiti +509+332',
      'Honduras +504+340',
      'Hong Kong +852+344',
      'Hungary +36+348',
    ],
    I: [
      'Iceland +354+352',
      'India +91+356',
      'Indonesia +62+360',
      'Iran +98+364',
      'Iraq +964+368',
      'Ireland +353+372',
      'Israel +972+376',
      'Italy +39+380',
    ],
    J: [
      'Jamaica +1876+388',
      'Japan +81+392',
      'Jordan +962+400',
    ],
    K: [
      'Kazakhstan +7+398',
      'Kenya +254+404',
      "Korea, Democratic People's Republic of +850+408",
      'Korea, Republic of +82+410',
      'Kuwait +965+414',
      'Kyrgyzstan +331+417',
    ],
    L: [
      'Laos +856+418',
      'Latvia +371+428',
      'Lebanon +961+422',
      'Lesotho +266+426',
      'Liberia +231+430',
      'Libya +218+434',
      'Liechtenstein +423+438',
      'Lithuania +370+440',
      'Luxembourg +352+442',
      'Rwanda +250+646',
    ],
    M: [
      'Macau +853+446',
      'Madagascar +261+450',
      'Malawi +265+454',
      'Malaysia +60+458',
      'Maldives +960+462',
      'Mali +223+466',
      'Malta +356+470',
      'Martinique +596+474',
      'Mauritius +230+480',
      'Mexico +52+484',
      'Moldova +373+498',
      'Monaco +377+492',
      'Mongolia +976+496',
      'Montserrat +1664+500',
      'Morocco +212+504',
      'Mozambique +258+508',
      'Myanmar +95+104',
    ],
    N: [
      'Namibia +264+516',
      'Nauru +674+520',
      'Nepal +977+524',
      'Netherlands +31+528',
      'Netherlands Antilles +599+530',
      'New Zealand +64+554',
      'Nicaragua +505+558',
      'Niger +227+562',
      'Nigeria +234+566',
      'Norway +47+578',
    ],
    O: [
      'Oman +968+512',
    ],
    P: [
      'Pakistan +92+586',
      'Panama +507+591',
      'Papua New Guinea +675+598',
      'Paraguay +595+600',
      'Peru +51+604',
      'Philippines +63+608',
      'Poland +48+616',
      'Portugal +351+620',
      'Puerto Rico +1787+630',
    ],
    Q: [
      'Qatar +974+634',
    ],
    R: [
      'Reunion +262+638',
      'Romania +40+642',
      'Russia +7+643',
    ],
    S: [
      'Saint Lucia +1758+662',
      'Saint Vincent and the Grenadines +1784+670',
      'Samoa +685+882',
      'San Marino +378+674',
      'Sao Tome and Principe +239+678',
      'Saudi Arabia +966+682',
      'Senegal +221+686',
      'Seychelles +248+690',
      'Sierra Leone +232+694',
      'Singapore +65+702',
      'Slovakia +421+703',
      'Slovenia +386+705',
      'Solomon Islands +677+90',
      'Somalia +252+706',
      'South Africa +27+710',
      'Spain +34+724',
      'Sri Lanka +94+144',
      'Sultan +249+736',
      'Suriname +597+740',
      'Swaziland +268+748',
      'Swedish +46+752',
      'Swiss +41+756',
      'Syria +963+760',
    ],
    T: [
      'Taiwan +886+158',
      'Tajikistan +992+762',
      'Tanzania +255+834',
      'Thailand +66+764',
      'Togo +228+768',
      'Tonga +676+776',
      'Trinidad and Tobago +1809+780',
      'Tunis +216+788',
      'Turkey +90+792',
      'Turkmenistan +993+795',
    ],
    U: [
      'Uganda +256+800',
      'Ukraine +380+804',
      'United Arab Emirates +971+784',
      'UK +44+826',
      'United States +1+840',
      'Uruguay +598+858',
      'Uzbekistan +998+860',
    ],
    V: [
      'Venezuela +58+862',
      'Vietnam +84+704',
    ],
    Y: [
      'Yemen +967+887',
    ],
    Z: [
      'Zambia +260+894',
      'Zimbabwe +263+716',
    ],
  },
  etfAdd: {
    fundRate: 'Fund Rate',
    title: 'ETF',
    dialogTitle: 'Disclaimer',
    confirmText: 'It is necessary to agree with',
    dText1: 'Dear users：',
    dText3: 'Thanks for login and use the leverage ETF products and relevant services (hereinafter “Leveraged ETF”) provided by our Exchange . Please read the instruction of Leveraged ETF and the following risk tips carefully. If you continue to use the leveraged ETF after reading the content aforesaid, it will be deemed that you agree all the content of the disclaimer, and you are fully aware of the risks of leveraged ETF and are able to bear the losses caused by it.',
    dText4: 'Please read the instruction of Leveraged ETF and the following risk tips carefully：',
    dText5: '《FAQ for Leveraged ETF》',
    dText6: 'Risk tips:',
    dText7: '1.Your purchase/selling price shall not derivate too much from the net value, otherwise you will encounter relevant losses.',
    dText8: '2.If you put the order in the opposite direction, there is a risk that the price will approach zero in extreme conditions.',
    dText9: 'Our Exchange hereby remind you that any losses incurred by the risks mentioned above shall be borne by yourself. This disclaimer, together with other agreements, statements, rules, etc. on Exchange, constitutes the entire agreement that users shall be agreed before using the services and products of Exchange.',
    sbyText1: '1. “3L" means that the price of the underlying transaction pair has increased by 1%, and the net value of the product has increased by 3%',
    sbyText2: '2. "3S" means that the price of the underlying transaction pair fell by 1%, and the net value of the product increased by 3%',
    sbyText3: '3. The net value is normally adjusted at 0 o’clock every day, and the extreme market will be adjusted in the intraday.',
    sbyText4: '4. A corresponding management fee will be charged daily for each leveraged multiple.',
    sbyText5: '5. Users shall pay attention to the net value of the product before trading. There is a risk that the price will approach zero in extreme conditions. Please watch out the risk in investment.',
    sbyText6: 'See more details',
    jz: 'Net Value',
    jzText1: 'Net Value For Long = Net value at the last adjustment point * [1+ 3 * (Latest spot transaction price-spot last adjustment point price) / spot last adjustment point price * 100%]；',
    jzText2: 'Net Value For Short = Net value at the last adjustment point * [1- 3 * (Latest spot transaction price-spot last adjustment point price) / spot last adjustment point price * 100%]；',
  },
  // translate
  broker: {
    broker: 'Broker system',
    invitations: 'Total invitees',
    indirect: 'Direct invitees',
    myType: 'My role',
    revenue: 'Total income',
    export: 'Export document',
    promptText1: 'UID',
    promptText2: 'Phone number',
    promptText3: 'Email',
    time: 'Time',
    phoneeNumber: 'Phone number',
    email: 'Email address',
    remaid: 'Commission record',
    agentAccount: 'Position statistics',
    tier: 'Degrees',
    fee: 'Fee',
    amount: 'Commission limit',
    opera: 'Operation',
    ccNumber: 'Position',
    view: 'View',
    symbolType: 'Coin',
    type: 'Type',
    returnDetails: 'Commission Details',
    scale: 'Commission ratio',
    startTime: 'Start time',
    endTime: 'End Time',
  },
  // translate
  pageTitle: {
    market: 'market',
    login: 'Log In ',
    register: 'Sign Up ',
    resetPass: 'Forgot password ',
    personal: 'My Account ',
    order: 'Orders ',
    assets: 'Assets ',
    trade: 'Spot trading ',
    home: 'Home ',
    cms: 'Help center',
    mesage: 'Message',
    noticeInfo: 'Announcement',
    otcTrade: 'Ad Details',
    otcRelease: 'Create ad',
    otcDetailOrder: 'Order Details',
    fiatdeal: 'Fiat',
    appDownload: 'APP Download',
    broker: 'Broker system',
    mining: 'Transaction mining',
    innovation: 'Innovation test area',
    contract: 'Futures Trading',
    manageFinances: 'Financial treasure ',
    manageFinancesView: 'Treasury details',
    manageFinancesOrder: 'Financial records',
    questions: 'FAQ',
    b2cFiatdeal: 'OTC',
  },
  header: {
    broker: 'Broker system',
    trade: 'Spot',
    otc: 'Buy Crypto',
    lever: 'Margin',
    co: 'Futures',
    assets: 'Assets',
    order: 'Order',
    zh: 'Simplified Chinese',
    login: 'Log In',
    register: 'Sign Up ',
    more: 'View more ',
    moreText: 'More',
    account: 'My account',
    message: 'Message',
    set: ' Settings',
    color: 'Mode',
    userStatus: 'Account status ',
    out: 'Log Out ',
    userStatus1: 'Normal ',
    userStatus2: 'Freeze the transaction, freeze the withdrawal ',
    userStatus3: 'Freeze the transaction 3 freeze the withdrawal ',
    minings: 'Transaction mining',
    innov_tit: 'Innovation test area',
    appDownLoad: 'App Download',
    market: 'Markets',
    up_down_color: 'Color preference',
    red_up_green_down: 'Red Up / Green Down',
    green_up_red_down: 'Green Up / Red Down',
  },
  krwAdd: {
    bod: 'Date of birth',
    regst1: 'Privacy Policy',
    regst2: 'User Service Agreement',
    regst3: 'Marketing advertising use consent',
    regstmust: '(Required)',
    regstother: '(Optional)',
    hometitle: 'Reminder',
    hometext1: ' ',
    hometext2: ' ',
    hometext3: ' ',
    hometext4: ' ',
    hometext5: ' ',
    hometext6: ' ',
    hometext7: 'Do not remind again',
    hometext8: 'Confirm',
  },
  // translate
  personal: {
    exccAuth: {
      errorText1: 'Authorization denied. Please choose other methods to accomplish KYC.',
      text1: 'Country',
      text2: 'KYC Verification Option',
      text3: 'Manual Form Submission',
      text4: 'Proceed with SingPass',
      text5: 'Manual form filling.',
      text6: 'Fill in the form manually and submit the information according to the requirements of the platform.',
      text7: 'Login with SingPass and submit.',
      text8: 'Authorize the collection of information by logging into your SingPass account, no need to fill in the form. (For Singapore citizens, permanent residents, or foreign residents working locally.)',
    },
    exccAuthorization: {
      title: 'Please check your information, which cannot be modified after submission',
      title2: 'Real-name authentication',
      promptText1: 'Alias Name',
      promptText2: 'Gender',
      promptText3: 'Identity card/residence permit/passport number',
      promptText4: 'Full Name',
      promptText5: 'Nationality',
      promptText6: 'Residential Status',
      promptText7: 'Date of Birth',
      promptText8: 'Country of Birth',
      promptText9: 'Residential Address',
      promptText10: 'Mobile Number',
      promptText11: 'Mailing Address',
      promptText12: 'Source of Income',
      income1: 'Salary',
      income2: 'Investments',
      income3: 'Savings',
      income4: 'Pension',
      income5: 'Inheritance',
      income6: 'Family Financial Support',
      income7: 'Others',
      submit: 'Submit',
    },
    exccAuthForm: {
      promptText1: 'Full Name',
      promptText2: 'Gender',
      promptText3: 'Date of Birth',
      promptText4: 'Residential Address',
      promptText5: 'City',
      promptText6: 'Postal Code',
      promptText7: 'Nationality',
      promptText8: 'Identity card/residence permit/passport number',
      promptText9: 'Source of Income',
      text1: 'Re-upload',
      text2: 'Address Proof. Latest official doc. Name & Addr MUST match',
      text3: 'Please upload all photo in jpg/png/jpeg file format in size no more than 8MB.',
      text4: 'All the uploaded photos must be visibly clear and must not be altered or modified in any way',
      text5: 'Hats, sunglass or any other accessories that may cover your face is not allowed. Make-up is also highly not recommended. The person holding the ID should have clear and identifiable facial features, with their entire arm visible.',
      text6: 'For the 3rd photo upload, you are required to hold the FRONT of your ID/passport/driving license together with a handwritten paper. The handwritten paper must include: 1) your full name, 2) submission date, 3) our web domain name and 4) a statement to declare your personal responsibility; "All behaviors on this website is performed by myself and I am aware of the relevant risks; and is willing to take all legal consequences.',
      text7: ' Proof of Address. Please upload full page of Utility Bill (e.g. Gas, Water or Electricity) or Bank Statement or Mobile/Telco Bill or Internet Bill dated within last 6 months. Ensure Full Name and Address matches.',
      text8: 'Re-upload',
      text9: 'Back of ID card / Passport Cover',
      text10: 'Re-upload',
      text11: 'Front of ID card/ Passport Information Page',
      text12: 'Re-upload',
      text13: "Selfie with ID and note 'exchange name and today's date'",
      text14: 'In the platform authentication, you need to be at least',
      sex1: 'OMale',
      sex2: 'OFemale',
      text15: 'Please describe the source of income',
      text16: "Please insert date of birth in 'yyyy-mm-dd' format",
      text17: 'Example: yyyy-mm-dd',
      text18: 'KYC verification is required before trading. Please submit your KYC.',
      text19: 'KYC verification is required before any deposit or withdrawal. Please submit your KYC.',
    },
    kyc: {
      areaTitle: 'Nationality',
      area: 'Select your country or region',
      kycAuth1: 'Please scan the QR code below with your phone,open the verification page. ',
      kycAuth2: 'Take photos of both sides of the ID card,your verification will be completed after passing face recognition.',
      kycAuth3: 'QR code validity period:',
      kycAuth4: 'The QR code has expired， please refresh the page.',
      kycAuth5: 'Verification Completed',
      kycAuth6: 'Continue to complete the certification on the current interface?',
      kycAuth7: 'Already exists',
      kycAuth8: 'Please scan the QR code to complete the verification',
      kycAuth9: 'Please complete identity certification through staff service',
      kycMin: 'Min',
      kycSec: 'S',
      type: 'Photo ID Types',
      name: 'First Name',
      fName: 'Last Name',
      text1: 'Please Note: One forms of identification with photo are required (passport preferred).',
      text2: ' ',
      type1: 'Passport',
      type2: 'National ID Card',
      type3: 'Driving License',
      type4: 'Other Photo ID',

      valueText1: 'ID 1 number',
      valueText2: 'ID 2 number',

      value1: 'Passport No.',
      value2: 'National ID Card No.',
      value3: 'Driving License No.',
      value4: 'Other Photo ID No.',
      Optional: 'Optional',
      require: 'Required',
    },
    krw: {
      authType: 'Korea',
      authOther: 'Foreigner',
      auth: 'Verification',
      niceN: 'Mobile identity verification (Korean vertification entry)',
      niceText: 'Used for platform to confirm your identity information',
      bank: 'Bank card',
      bankText: 'Can be withdrawals after linked',
      authLevel: 'ID Verification',
      authLevelText: 'For your asset security, please complete the verification as soon as possible',
      account: 'Account',
      selectArea: 'Please select your nationality',
      niceConfrim: 'Vertified',
      niceConfrimTitle: 'Mobile identity verification',
      niceConfrimText: 'Mobile identity verification, waiting...',
      alertText: 'For the security of your account, please enable two factor authentication.',
      inow: 'I know it',
      alertk: 'Mobile identity verification or identity verification',
      OTPk: 'OTP vertification',
      phonek: 'Please improve your mobile phone identity vertification first',
    },
    krwBank: {
      addBank: 'Link bank account',
      setBank: 'Change bank account',
      userName: 'Name',
      country: 'Countries',
      bankAccount: 'Bank account number',
      bankAccountError: 'Please enter the correct bank account',
      smsCode: 'SMS verification code',
      smsCodeError: 'Please enter the 6-digit SMS verification code',
      googleCode: 'Google authentication code',
      googleCodeError: 'Please enter the 6-digit Google verification code',
    },
    label: {
      smsCodeText: ' SMS verification code',
      googleCodeText: 'Google authentication code',
      emailCodeText: 'E-mail verification code',
      newEmailCodeText: 'New e-mail verification code',
      moneyPassword: 'Funds Password',
      oldMoneyPassword: 'New Funds Password',
      newConfirmMoneyPassword: 'Confirm Funds Password',
      confirmMoneyPassword: ' Confirm New Funds Password',
      ipText: 'IP address',
      noteText: 'Notes',
      promptText: 'Nationality',
      errorText: 'Please select country',
      phone: 'Mobile number',
      oldPhone: 'Initial mobile number',
      newPhone: 'New mobile number',
      oldPassword: 'Initial password',
      password: 'Password',
      newPassword: 'New password',
      newPasswordAgain: 'Confirm password',
      oldEmail: 'Initial e-mail address',
      newEmail: 'New e-mail address',
      email: 'E-mail address',
      idCard: 'ID card',
      idCardNum: 'ID Number',
      promptText1: 'Address (Please note that the address must match the address proof provided in the next step)',
      passport: 'Passport',
      name: 'Name',
      inviteCode: 'Invitation code',
      inviteUrl: 'Invitation link',
      inviteQECode: 'My QR code',
      inviteTitle: 'My invitation',
    },
    tool: {
      modify: 'Change ',
      bind: 'Connect ',
      delete: 'Delete ',
      setUp: 'Settings',
      add: 'Add ',
      submit: 'Submit',
      create: 'Create ',
      view: 'View ',
      confirm: 'Confirm ',
    },
    prompt: {
      errorTextName: 'Nickname cannot be blank ',
      errorTextLength: 'The length of the nickname cannot exceed ten digits ',
      ipErrorText: 'Please enter the correct iP address ',
      copySucces: 'Copied',
      errorCode: 'Please enter a 6-digit verification code ',
      errorPhone: 'Please enter the correct mobile number ',
      errorPhoneText: 'Please enter your mobile number ',
      errorNewPhone: 'Please enter a new mobile number ',
      ipCode: 'Please enter the correct IP address ',
      noteCode: 'Please enter a comment ',
      uploading: 'Uploading ',
      uploadQrCod: 'Upload QR code image ',
      uploadQrCodAgain: 'Upload QR code image again ',
      uploadType: 'Support the jpg/png, with size less than 8M',
      warningApi: 'Please do not divulge the key to others to avoid assets loss. A single user can create up to 5 keys. It is recommended to link the IP to the key. Each key is bound with maximum 5 IP addresses, separated by commas. ',
      warningChangePhone: 'It is forbidden to withdraw coins within 48 hours after modifying the phone. ',
      warningChangePassword: 'It is forbidden to withdraw coins within 48 hours after modifying the login password. ',
      warningChangeEmail: 'It is forbidden to withdraw coins within 48 hours after modifying the email. ',
      warningPassword: 'It is not possible to withdraw coins within 48 hours after the changing the fund’s password',
      errorPasswordText: 'Please enter 8 to 20 digits, including numbers and letters ',
      errorPasswordTwo: 'The two new password entries are not the same',
      errorEmailText: 'Please enter the correct email address',
      errorEmail: 'Please enter your e-mail address',
    },
    state: {
      certification: 'Verification',
      certified: 'Verified',
      authentication: 'Verificating',
      closeValidatio: 'Turn off',
      openValidatio: 'Turn on',
      open: 'Already turned on',
      closeSuccess: 'Turn off successfully',
      openSuccess: 'Turn on successfully',
      release: 'Releasing ',
      trading: 'Trading',
      overdue: 'Overdue',
      close: 'Close',
      closed: 'Closed ',
    },
    alert: {
      title: 'For the security of your account, please enable at least one verification method.',
      button: 'Settings',
      fiatTitle: 'Fiat currency setting reminder',
      buttonOpen: 'Activate',
      certif: 'Verificate',
      text: 'For the security of your account, please open at least one verification method.',
      enforceGoogleAuth: 'Please complete the identity verification, set the nickname and open google authentication first before adding the payment method and setting fund password.',
      fiatText: 'Your account must be verified by your real name, also you must set a nickname, open at least one security verification method to add payment methods and set up fund’s passwords.',
      alertErrorTextGoogle: 'Link Google verification',
      alertErrorTextPhone: 'Link mobile phone verification',
      nickName: 'Nickname',
      id: 'verification',
      textOpen: 'You have to link and activate at least one payment method, only after that you can sell digital currency',
      payTypeError: [
        'Buyers only accept payment via ',
        ' Please choose and add payment method and activate it.',
      ],
    },
    dialog: {
      title: 'Change the nickname',
      name: 'Nickname',
      text: 'Please enter the nickname',
      closeAd: 'Close the ad',
      closeAdPrompt: 'Closing the ad will lead to stop the trade. Are you sure you want to close this ad?',
      blackPrompt: 'Reminder',
      blackPromptText: 'Are you sure to remove the other party from your blacklist?',
    },
    navMenu: {
      title: 'My account',
      list: {
        inviteCodeManagement: 'Invitation Code Management',
        userManagement: 'Account management',
        safetyRecord: 'Safety record',
        leaglTenderSet: 'Fiat settings',
        advertisingManagement: 'Ad Management',
        blackList: 'Blacklist',
        apiManagement: 'API management',
      },
    },
    userManagement: {
      nameError1: 'Your nickname can not be blank',
      nameError2: 'Your nickname cannot exceed ten digits',
      nameError3: 'Only English letters, numbers (0-9), Chinese characters, and special characters (“-”,“_”) are allowed',
      userName: 'Nickname',
      id: 'ID',
      securityTitle: 'Security Settings',
      otherTitle: 'Other',
      inviteLink: 'My invitation',
      securityList: {
        password: {
          text: 'Login Password',
          label: '***********',
        },
        idAuth: {
          text: 'KYC Verification',
          label: 'Please start to verify your account',
        },
        email: {
          text: 'Email',
          label: 'Used when logging in, withdrawing and modifying security settings',
        },
        phone: {
          text: 'Phone number',
          label: 'Receive SMS messages used for withdrawals, changing your password or changing security settings.',
        },
        google: {
          text: 'Google Authenticator ',
          label: 'API Secure verification when withdrawing, retrieving passwords, modifying security settings and managing API',
        },
      },
      otherList: {
        poundage: {
          text: 'Pay fees using tokens can be used for market and trading fees',
          label: 'Used as an exchange market, trading currency unit',
        },
        myInviteCod: {
          text: 'My invitation code',
          label: 'Invite new users, earn rewards!',
        },
        myInvite: {
          text: 'My invitation',
          // label: '用于邀请新用户',
        },
        superPeerCod: {
          text: 'Super Node',
          // label: '用于邀请新用户',
        },
        superDeputyCod: {
          text: 'Master Affiliate',
          // label: '用于邀请新用户',
        },
      },
    },
    safetyRecord: {
      navTab: [
        'Login History',
        'Security Settings History',
      ],
      loginColumn: [
        'Time',
        'Type',
        'IP',
        'Status',
      ],
      settingColumn: [
        'Time',
        'Security Settings',
        'IP',
      ],
      success: 'Successful',
      failure: 'Failed ',
    },
    inviteCodeManagement: {
      title: 'Invite friends and get commission from their tradings ',
      titleText: 'Get 30% of service charge as commission on the same day.',
      showNumber: 'Number of invited',
      showCommission: 'Commission ',
      commissionWay: 'Invitation method',
      commissionRecor: 'Invite History',
      columns: [
        'Time',
        'Invited Account',
      ],
    },
    myInvite: {
      title1: 'The more you trade ',
      title2: ', the more you earn',
      title3: 'Say Goodbye',
      title4: '',
      title5: 'High transaction fees',
      my: 'My Referral',
      number: 'Invitees',
      reward: 'Referral incomes ({coin})',
      profits: 'Mining rebates ({coin})',
      code: 'Default referral code',
      link: 'Default referral link',
      invite: 'Refer Now',
      details: 'Referral details',
      myReward: 'Income',
      list: 'Referral list',
      profitsList: 'Mining rebates',
      time: 'Registration date',
      user: 'User name',
      status: 'Status',
      miningDetails: 'Mining details({coin})',
      miningRewards: 'The invitation mining reward ({coin})',
      statusItem1: 'unissued',
      statusItem2: 'issued',
    },
    leaglTenderSet: {
      title: 'Payment Management',
      titleList: [
        {
          text: 'Payment Method setting',
          label: 'Please use your own verified account. The activated payment methods will be displayed to the buyer during the transaction, up to 3 can be activated.',
        },
        {
          text: 'Trade Password',
          label: 'To ensure the security of your funds, please set up the trade password',
        },
      ],
    },
    setUp: {
      title1: 'Set up the Receiving Method',
      title2: 'Add a Receiving Method',
      hint: 'Each fiat currency can be bound to a bank card, up to 4 bank cards',
      paymentMethods: {
        text: 'Receiving Method',
        errorText: 'Please choose the Receiving method',
        text2: 'fiat currency',
        errorText2: 'Please select fiat currency type',
        paymentsWA: {
          name: 'Name',
          title: 'Account',
          type: 'Account Type',
        },
        paymentsCard: {
          name: 'Name',
          bank: 'Bank Name ',
          branch: 'Branch Info (optional) ',
          branchInfo: 'Branch Info',
          account: 'Bank Account ',
          swiftCode: 'SWIFT code',
          ibanNumber: 'IBAN number',
        },
        buyerUse: 'Buyer has used',
      },
    },
    advertisingManagement: {
      navTab: [
        ' Buy ad',
        'Sell ad',
      ],
      columns: [
        'Time',
        'ID',
        'Currency',
        'Price',
        'Amount',
        'Status',
      ],
    },
    blackList: {
      title: 'Blacklist',
      columns: [
        'User',
        'Credit value',
        'Trade history',
        'Trades',
        'Operation',
      ],
      closeText: 'Remove from the blacklist',
    },
    APImanagement: {
      navTab: [
        'Create API Key',
        'API  Quotation Document',
        'API Transaction Document',
      ],
      columns: [
        'Notes',
        'Connect IP Address',
        'APIKey',
        'SecretKey',
        ' Operation',
      ],
      columnsApi: [
        'Interface',
        'description',
      ],
      recordTitle: 'API record',
      downloadDocumen: 'Download the document',
      titleText: 'Confirm the key',
      secretKey: 'SecretKey',
      APIKye: 'APIKey',
      ip: 'IP address',
      note: 'Notes',
      apiList: [
        'Get K Line Data',
        'Transaction Record',
        'Query Order Depth',
        'Get all orders ',
        'Get all transaction records',
        'Cancel order',
        'Query all transaction pairs and the degree of accuracy supported by the system ',
        'Create Order',
        'Get the latest transaction price for all currency pairs',
        'Get current order',
        'Get order details',
        'Asset balance',
      ],
    },
    checkApi: {
      title: 'View SecretKey',
    },
    modifyApi: {
      title: 'Modify APIKey',
    },
    changePhone: {
      title: 'Change the phone number',
    },
    changePassword: {
      title: 'Modify login password',
    },
    changeEmail: {
      title: 'Modify e-mail',
    },
    bindEmail: {
      title: 'Link e-mail',
    },
    bindGoogle: {
      title: 'Link Google authentication ',
      downloadGoogle: [
        'APP Download Google Authenticator APP',
        'iOSApp Store“Authenticator”iOS users Login to the App Store to search for "Authenticator" downloads.”To Login, the Android users need use the app store or a mobile phone browser to search for "Google Authenticator" downloads',
      ],
      useGoogle: [
        'Scan a QR code with Google Authenticator or enter the key manually ',
        'Open Google Authenticator, scan the QR code below or enter the following key manually to add a verification token',
      ],
      bindGoogle: [
        'Complete linking ',
        'The key is used to retrieve the Google Authenticator when the phone is replaced or lost. Be sure to save the above key backup before binding. ',
      ],
      appStore: 'App Store',
      googlePlay: 'Google Play',
      android: 'Android',
    },
    bindPhone: {
      title: 'Link the mobile phone',
    },
    closeGoogle: {
      title: 'Disable Google Authenticator',
    },
    closePhone: {
      title: 'Disable the Mobile Phone Verification',
    },
    idAuth: {
      title: 'Verification',
      info: 'Basic Information',
      uploadDocuments: 'Upload Documents',
      submitted: 'Submitted',
      promptTextType: 'Document type',
      next: 'Next',
      uploadIdCardPositive: 'Face of your ID 1',
      uploadIdCardPositiveAgain: 'Upload the front side of the photo once again',
      uploadIdCardBack: 'Back of your ID 1(Passport  does not need to provide back )',
      uploadIdCardBackAgain: 'Upload the back side of the photo once again',

      uploadIdCardPositive2: 'Face of your ID  2',
      uploadIdCardPositiveAgain2: 'Upload the front side of the photo once again',
      uploadIdCardBack2: 'Back of your ID 2',
      uploadIdCardBackAgain2: 'Upload the back side of the photo once again',

      uploadIdCardPersonalPositiv: 'ID and personal signature photo',
      uploadIdCardPersonalPositivAgain: 'Upload the ID and personal signature photo once again ',

      uploadAddress: 'Proof of Residence ',

      uploadPassportPositive: 'Upload the front cover of the ID document ',
      uploadPassportPositiveAgain: 'Upload the front cover of the passport once again ',
      uploadPassportBack: 'Upload the ID document personal information page ',
      uploadPassportBackAgain: 'Upload the passport personal information page once again ',

      uploadPassportPersonalPositiv: 'A photo of holding the document and a personal signature',
      uploadPassportPersonalPositivAgain: 'A photo of holding the document and a personal signature once again',

      uploadText: [
        'Supports images in JPG, JPEG or PNG format that are less than 8MB.',
        'The ID photo must be clear, unmodified, and not covered, with visible facial features, ID number, and name. ',
        'The photo should be taken without a hat and makeup, and the person holding the ID should have clear facial features and show their entire arm. ',
        'Address proof: either the address on the ID card or a valid address. ',
        'Handheld ID and handwritten note: a photo of the applicant holding the ID card and a handwritten note that says "Name + Application Date',
      ],
      wait: [
        'Your identity information has been submitted',
        'Please wait patiently, your information is being reviewed.',
      ],
      step1: '1. Please download the mobile APP and complete the identity authentication operation in the APP.',
      step2: '2. Open the personal center in the APP in the mobile phone and follow the prompts to complete the authentication steps.',
      appDownLoad: 'Scan the QR code to download APP',
    },
    modifySettings: {
      setTitle: 'Set up the fund password',
      modifyTitle: 'Modify the fund password',
    },
  },
  // translate
  fiatdeal: {
    title: 'Fiat Trading',
    paySetting: 'Payment setting',
    myOrder: 'My Order',
    myAd: 'My AD',
    openA: [
      'More',
      'Fewer',
    ],
    navList: [
      'Buy/Sell',
      'Buy',
      'Sell',
      'Block',
      'Buy',
      'Sell',
      'Publish AD',
      'Apply Merchant ',
    ],
    center: {
      header: {
        text: 'Average Price ',
      },
      country: 'Countries',
      fiat: ' Fiat currency',
      payment: 'Payment Method',
      idinfo: 'Before you start trading, you need to improve the necessary identity information. ',
      columns: [
        'Merchant',
        'Amount',
        'Limits',
        'Price',
        'Payment Method',
        'Operation',
      ],
      buy: 'Buy ',
      sell: 'Sell ',
      trading: 'Trading ',
      credit: 'Credit ',
      all: 'All ',
    },
  },
  // translate
  stranger: {
    addBlackList: 'Add to the BlackList ',
    removeBlackList: 'Remove from the BlackList ',
    online: ' Online',
    offline: 'Offline ',
    already: 'Already ',
    never: 'Never',
    phone: 'Mobile',
    identity: 'ID',
    certification: 'Vertification ',
    headerList: [
      'Trades',
      'Total number of appeal',
      'Won amount',
    ],
    blackListPrompt: [
      'Are you sure you want to add the other party to the blacklist? ',
      'Are you sure you want to remove the other party from the blacklist? ',
    ],
    navTab: [
      'Buy ad',
      'Sell ad',
    ],
    columns: [
      'Currency',
      'Amount',
      'Limit',
      'Price',
      'Payment method',
      'Operation',
    ],
    buy: 'Buy ',
    sell: 'Sell ',
    view: 'View ',
  },
  home: {
    more: 'More',
    searchSy: 'Search',
    market: 'Markets ',
    close: 'Last Price ',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    H_volume: '24H Volume',
    H_turnover: '24H Turnover ',
    action: 'Action',
    marketSet: 'Favorites',
    chart: 'Chart',
    moreMarket: 'View More Market',
    bitsgtitle1: 'Any currency you want',
    bitsgtitle2: 'Popular currencies',
    bitsgtitle3: 'To trade',
    H_coNumber: 'Position',
    tab_USDT: 'USDT Margin',
    tab_USD: 'Coin Margin',
  },
  // translate
  trade: {
    dataType1: 'Original',
    dataType2: 'TradingView',
    dataType3: 'Depth',
    datatext1: 'O',
    datatext2: 'High',
    datatext3: 'Low',
    datatext4: 'C',
    datatext5: 'VOL',
    noUnlock: 'Deposit locked',
    freeUnlock: 'Unlocked Gifts',
    ySellVol: 'Available balance',
    unlockSellBtn: 'Flash Sell',
    modelInfo: ' Instruction',
    sellAll: 'See all',
    balance: 'Available balance',
    currencyNotesModal: {
      coinType: 'Currency abbreviation',
      fullNameCurrency: 'Currency name',
      issueTime: 'Issuance time',
      totalIssueAmount: 'Issuance gross',
      totalCirculation: 'Circulation gross',
      officialWebsite: 'Official website',
      blockQuery: 'Block query',
      Introduction: 'Introduction',
      relatedLinks: 'Related Links',
    },
    searchSy: 'Search',
    market: 'Markets',
    close: 'Last Price',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    vol: 'Volume ',
    H_volume: '24H Volume',
    H_turnover: '24H Turnover ',
    marketSet: 'Favorites',
    maincon: 'Main area',
    halving: 'Halving',
    newcon: 'New area',
    seecon: 'Observation Area',
    unseal: 'Unlock area',
    notData: 'No Records',
    handicap: 'Orderbook',
    latestDeal: 'Last trades',
    price: 'Price ',
    number: 'Amount ',
    total: 'Sum',
    time: 'Time ',
    activeOrder: 'Open orders',
    historyOrder: 'Order history',
    class: 'Side',
    transaction: 'Pair',
    average: 'Average Price',
    status: 'Status',
    opera: 'Action',
    deal: 'Executed',
    noDeal: 'Cancelled',
    turnover: 'Total(USDT)',
    serviceCharge: 'Fee',
    marketPrice: 'Markets',
    cancelOrder: 'Cancel',
    cancelled: 'Cancelled successfully ',
    view: 'Detail ',
    dealMoney: 'Total',
    limitPriceTrade: 'Limit',
    marketPriceTrade: 'Market',
    total_money: 'Estimated Value',
    buy: 'Buy ',
    sell: 'Sell ',
    loginReg: 'Log In or Sign Up',
    mPriceBuy: 'The best market price',
    mPriceSell: 'The best market price',
    pleaseLogin: 'Please login first',
    pleasePrice: 'Please enter the price',
    pleaseInput: 'Please enter',
    inputError: 'Incorrect input',
    dealCussess: 'Ordered successfully',
    full: 'Full screen',
    outFull: 'Exit full screen moden',
  },
  message: {
    mesage: 'Message Center',
    noticeInfo: 'Announcement',
    help_center: 'Help Center',
    selectAll: 'Select all',
    delete: 'Delete ',
    readAll: 'Mark all as read',
    pleSelContent: 'Please select the content to delete ',
    search: 'Search',
  },
  application: {
    policy: {
      title: 'Merchant verification agreement',
      desc: 'Global Professional Fiat trading Platform<br/>In order to ensure the safety of both parties in the transaction and enhance the credibility of the identity of registered users on this platform, we provide merchant authentication services. You must provide necessary and genuine personal information to complete the authentication. The platform reserves the right to take various legal measures to verify the information you provide, but due to the virtual nature of the network environment and the limitations of verification methods, the platform does not guarantee the accuracy and authenticity of the authenticated merchant\'s identity.<br/>All the contents of this agreement are closely related to your rights and obligations. Please read all the contents of this agreement carefully before applying for merchant authentication. Once you start the authentication process, it means that you are aware of and fully understand, and agree to accept all the contents of this agreement.<br/>I. Definition and Change of Authentication Services<br/>1. Authentication service refers to a service where merchants provide genuine and credible identity information, pay a certain deposit, and then enjoy certain privileges and undertake certain responsibilities on this platform. Unless there is a legal situation or otherwise stipulated in this agreement, once you have completed the authentication on this platform, the corresponding identity information and authentication results will not be modified or canceled for any reason; if your identity information changes after completing the authentication, you should provide the platform with the corresponding credentials issued by the competent authority, and the platform will assist you in changing your authentication information.<br/>2. In order to provide better quality services and ensure transaction security, the platform reserves the right to modify or adjust the contents of this agreement according to the changes in objective and subjective circumstances, and to announce the revised agreement text through the platform without the need to notify you individually. After any modification or change to this agreement, if you continue to use the services provided by this platform, it means that you have read, understood, and agreed to accept the revised agreement; if you do not agree to the revised agreement, you should immediately apply to the platform to discontinue the authentication service. <br/>II. Rights of Authenticated Merchants<br/>1. The platform will provide a unique authenticated merchant logo to merchants who have successfully applied for authentication. This logo can be used to distinguish authenticated merchants from non-authenticated merchants on the platform;<br/>2. Publish transaction advertisements that comply with regulations on the platform. <br/>III. Required Documents and Deposit for Authentication<br/>1. Merchant personal information: Please fill out and upload the attached merchant application information completely;<br/>2. Asset deposit: To apply to become an authenticated merchant, you need to pay a certain deposit to the platform. The deposit will be transferred to the authenticated merchant\'s deposit account. Authenticated merchants will not be able to trade or transfer funds in this account for a certain period. <br/>IV. Use of Authentication Information<br/>Authentication information report: The authentication information you submit to the platform during the authentication process is irrevocably authorized for the platform to retain. Except for statutory or agreed situations in this agreement, the platform promises not to edit or disclose your authentication information to any third party and not to use it for commercial purposes, except in the following cases:<br/>1. Information you authorize the platform to disclose;<br/>2. Information provided to national judicial and administrative authorities by the platform;<br/>3. Information provided to the platform\'s affiliated companies;<br/>4. Relevant information (excluding your bank account information) required by the third party to provide you with services when the third party and the platform jointly provide services to you;<br/>5. The platform reserves the right to provide your identity information to a third party to resolve civil disputes between you and the third party.<br/>V. Use of Deposit<br/>The deposit is used to ensure the security of related transactions conducted on the platform. If a dispute arises during the transaction process and you are determined to be responsible for the dispute and should perform corresponding actions, but you do not cooperate, the platform has the right to dispose of the deposit. Disposal measures include but are not limited to withholding, freezing, or directly paying to your trading counterpart.<br/>VI. Links to Third-Party Websites<br/>In order to verify identity information, the platform may contain links to third-party websites (such as online banking websites) (hereinafter referred to as "linked websites"). "Linked websites" are not controlled by the platform, and the platform is not responsible for any content of any "linked website", including but not limited to any links contained within the "linked website", or any changes or updates to the "linked website". The platform is not responsible for any network transmissions or other forms of transmission received from the "linked websites". <br/>VII. Prohibited Use<br/>Accepting the full explanation, terms, and conditions of this agreement is a prerequisite for your application for authentication. You represent and warrant that you will not apply for authentication for any illegal or prohibited purposes as set forth in this agreement, terms, and notices. You may not use the authentication service in any way that may damage, disable, overload, or impair any other website or the services of any other website or the platform, or interfere with others\' use of the authentication merchant application. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available by the platform. <br/>VIII. Disclaimer<br/>The platform is not responsible for any leakage of personal information or data in the following situations:<br/>1. The disclosure of your personal information due to your disclosure of your account password to others, improper safeguarding of your password, sharing your account with others, or any other fault not caused by the platform.<br/>2. Any leakage, loss, theft, or tampering of authentication information caused by hacker attacks, computer virus intrusion or outbreak, the impact of technical adjustments by the telecommunications department, shutdown due to government policies or legal regulations, third-party reasons (including force majeure, such as international backbone line failures and international export telecommunications provider failures, fires, floods, lightning strikes, earthquakes, floods, typhoons, tornadoes, volcanic eruptions, epidemics and pandemics, strikes, war or acts of violence or similar events, etc.) and other causes not attributable to the platform.<br/>3. The leakage of bank account information caused by other websites linked to the platform (such as online banking) and any resulting legal disputes and consequences.<br/>4. Any failure to pass authentication or suffer any other loss due to the user providing incorrect, incomplete, or false information to the platform is not related to the platform.<br/>IX. Special Statement<br/>1. The platform\'s basic information review and deposit requirements for authenticated merchants do not guarantee that authenticated merchants are 100% trustworthy, nor does it imply any guarantee relationship between the platform and authenticated merchants. Users of the platform are advised to trade strictly according to the process, conduct thorough reviews of the transaction party\'s information, communicate in detail, and ensure the security of their transactions and assets! At the same time, due to the special nature of digital asset transactions, you need to pay special attention to anti-money laundering risks, understand the identity of your trading counterpart according to the requirements of the KYC principle, otherwise, you may face the risk of asset freezing due to the suspected criminal activities of the trading counterpart.<br/>2. Authenticated merchants promise that the information provided to the platform is true and legal. If there is any falsification or violation, the platform may cancel their authentication and withhold their deposit.<br/>X. Authentication Termination<br/>If authenticated merchants need to terminate the authentication, they must submit an application to the platform. If authenticated merchants have no adverse records, affect transaction security, or engage in illegal or non-compliant behavior during the authentication period, the platform will review and approve the application within two working days after receiving the application and transfer the funds in the security deposit account to the operational account of the merchant who requested the cancellation of certification.',
    },
    applyCompany: 'Merchant application',
    applyCompanyDesc: 'Become a merchant and enjoy more trading privileges.',
    serviceList: [
      {
        title: 'Security ',
        desc: 'Every merchant information is strictly confidential and is never Divulged',
      },
      {
        title: 'Publish AD',
        desc: 'Merchants can freely publish advertisements, making buying and selling more flexible and convenient.',
      },
      {
        title: 'Verified Badges ',
        desc: 'The merchant\'s name will be followed by an exclusive V logo, enhancing trust between trading parties.',
      },
      {
        title: 'Exclusive Customer Support ',
        desc: 'We will provide one-to-one exclusive services to merchants',
      },
    ],
    congratulate: 'Congratulations, you have passed the verification and become a merchant',
    congratulateSuper: 'Congratulations, you have passed the verification and become a super merchant ',
    applyBtn: 'Apply now',
    applyBtnSuper: 'Apply for super merchant',
    relieve: ' Cancel verification',
    confirm: 'Confirm',
    cancel: 'Cancel',
    agree: ' I have read and agree to the',
    agreePolicy: '《Verified Merchant Agreement》',
    relieveing: 'Canceling ',
    dialogDesc: 'After the cancel of the verification you will not be able to post ads, are you sure you want to cancel it? ',
    stepProgress: [
      {
        text: 'Waiting for the application ',
        status: 0,
      },
      {
        text: 'In the process of application ',
        status: 1,
      },
      {
        text: 'Completed',
        status: 3,
      },
    ],
    applyRegion: {
      options: [
        'Agree to freeze',
        'Used as a merchant deposit',
      ],
      applyBtn: 'Apply',
      applingBtn: 'In the process of application',
      appliedBtn: 'Return',
      cancelBtn: 'Cancel application',
      focus: 'Attention ',
      focusContent: 'You must become a super merchant to be able to place advertisement in the trading areas. The merchant can apply to become a super merchant if he or she has a high transaction efficiency, good reputation and agree to pay a large amount of security deposit.   ',
      focusContentSuper: 'The merchant can apply to become a super merchant if he or she has a high transaction efficiency, good reputation and agree to pay a large amount of security deposit.  ',
    },
    company: {
      head: {
        title: 'Learn about how to become a merchant. ',
        desc: 'Please follow the steps below to complete the application conditions',
        titleAppling: 'Please wait patiently during applying',
        titleApplied: 'Congratulations, you have become a merchant',
        descApplied: 'You can enjoy the following trading privileges',
      },
      unApply: {
        stepOne: {
          title: 'Step 1: Submit Your Application',
          desc: [
            'To become an accredited merchant on Mal.io, follow these simple steps:',
            '1. Fill out the',
            'Application Submission',
            ' Application Submission questionnaire.',
            "2. After completing the questionnaire, click the 'Submit Application' button on this page.<br />3. Additionally, agree to secure your merchant status by freezing 500 USDT.<br />4. Once your application is successfully submitted, you can start posting advertisements in the P2P trading area.<br />We're here to help you every step of the way!",
          ],
        },
        stepTwo: {
          title: 'Step 2: Application Review',
          desc: [
            "We're excited to review your application for merchant status, and we promise to do it promptly. You can expect to hear back from us within the next 24 hours. Thank you for choosing us!",
          ],
        },
        stepThree: {
          title: 'Step 3 Submit an application ',
          desc: [
            'After sending the e-mail, please click the "Confirm Application" button on this page to submit your application. And also agree to freeze ',
            'Used as a merchant deposit. When the submission is complete, you can post your ad in the normal trading area ',
          ],
        },
        stepFour: {
          title: 'Step 4 Data verification ',
          desc: [
            'We will check your merchant application information within 3 working days, please keep your communication as usual, we will get in touch with you on our own initiative. ',
          ],
        },
      },
      applying: {
        desc: '1.The application was submitted successfully and your information is under review. <br/><br/>  2. Your cash deposit has been frozen. <br/><br/> 3. You have submitted your application. If the information is submitted correctly, our staff will approve it within 3 working days.',
      },
      applied: {
        desc: '1. Merchants can freely post ads to make business more flexible and convenient. <br/><br/> 2. The merchant\'s name will be followed by an exclusive V logo, enhancing trust between trading parties. <br/><br/> 3. We will provide one-to-one exclusive services to merchants ',
      },
    },
    companySuper: {
      head: {
        title: 'How to become a super merchant？',
        desc: 'Please follow the steps below to meet application requirements',
        titleAppling: 'Please wait patiently, your information is being reviewed',
        titleApplied: 'Congratulations, you have become a super merchant',
        descApplied: 'You can enjoy the following trading privileges',
      },
      unApply: {
        stepOne: {
          title: 'Step 1 Submit an application ',
          desc: [
            'Please click the "Apply for becoming a merchant" button on this page. And agreed to increase the freeze by',
            'Used as a security deposit for upgrading to a Super Merchant. Once the submission is complete, you can post the trade ads.',
          ],
        },
        stepTwo: {
          title: 'Step 2 Review ',
          desc: [
            'We will check your application information within 3 working days, please keep your communication as usual, we will get in touch with you on our own initiative .',
          ],
        },
      },
      applying: {
        desc: '1.The application was submitted successfully and your information is under review. <br/><br/> 2. Your cash deposit has been frozen. <br/><br/> 3. You have submitted your application. If the information is submitted correctly, our staff will approve it within 3 working days.',
      },
      applied: {
        desc: '1. Super merchants can freely post advertisements in any area,  that is making trading more flexible and convenient. <br/><br/> 2. The merchant\'s name will be followed by an exclusive V logo, enhancing trust between trading parties. <br/><br/> 3. We will provide one-to-one exclusive services to merchants.',
      },
    },
    unEnough: 'Insufficient Fiat balance available for account',
  },
  login: {
    WelcomeToLogin: 'Log In',
    NotRegisteredUsersYet: 'Don\'t have an account',
    goRegister: 'Sign Up',
    phoneOrEmail: 'Email or phone number',
    formatIncorrect: 'The input format is incorrect',
    password: 'Password ',
    passwordError: 'Please enter 8 to 20 digits, including numbers and letters',
    VerificationMode: 'Verification mode ',
    AuthenticationMethod: 'Please select the verification method ',
    ForgetPassword: 'Forgot Password?',
    login: 'Log in ',
    SecurityVerification: 'Security Verification ',
    MailboxValidation: 'Email Verification ',
    MobilePhoneVerification: 'SMS Verification ',
    GoogleAuthenticator: 'Google Verification ',
    googleCodeError: 'Please enter a 6-digit Google verification code',
    phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
    emailCodeError: 'Please enter a 6-digit email verification code',
    codeError: 'Please enter a 6-digit  verification code ',
    googleCode: 'Google verification code ',
    phoneCode: 'SMS verification code ',
    emailCode: 'Email verification code',
    code: 'Verification code',
    loginSuccess: ' Login success',
    phoneSendSuccess: 'SMS has been sent, please check it',
    emailSendSuccess: 'The e-mail has been sent, please check it',
    loginPrompt: '(Mobile phone login does not require adding a country code.)',
  },
  register: {
    phoneRegister: 'Phone number',
    emailRegister: 'Email address',
    WelcomeToRegister: 'Welcome to register',
    AlreadyAregisteredUser: 'Already have an account',
    logInImmediately: 'Login now',
    location: 'country ',
    PleaseSelectAcountry: 'Please select a country ',
    password: 'Password ',
    passwordError: '8-20 characters, include letters & numbers, symbols: _~!@#$%^&*()',
    confirmPassword: 'Confirm the password',
    confirmPasswordError: 'The two new password entries are not the same',
    InvitationCodeError: 'Please enter the invitation code',
    IHaveReadAndAgreed: 'I have read and agree to the',
    UserAgreement: 'User Service Agreement',
    UserAgreementLink: 'https://exchange.zendesk.com/hc/en-us/articles',
    register: 'Sign Up',
    phone: 'Phone number ',
    phoneError: 'The phone number input format is incorrect ',
    phoneCode: 'SMS verification code ',
    phoneCodeError: 'Please enter a 6-digit SMS verification code ',
    email: 'Email address ',
    emailError: 'The email input format is incorrect ',
    emailCode: 'Email verification code',
    emailCodeError: 'Please enter a 6-digit mailbox verification code ',
    InvitationCodeOptional: 'Invitation code (optional) ',
    InvitationCodeIsRequired: 'Invitation Code ',
    registerSuccessQLogin: 'Registration success. Has logged ',
    scrollCode: 'Please complete the security verification to get the verification code.',
    phoneSendSuccess: 'SMS has been sent, please check it ',
    emailSendSuccess: 'The Email has been sent, please check it ',
    registerSuccess: 'Registration success. please Login ',
    passwordStrength: 'Password Strength',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    strengthCondition_1: '8 to 20 characters including numbers',
    strengthCondition_2: 'Uppercase or Lowercase letters',
    strengthCondition_3: 'Special symbols',
  },
  resetPass: {
    googleCode: 'Google authentication code ',
    googleError: '6Please enter a 6-digit Google authentication code',
    IDCode: 'ID number',
    IDError: 'Please enter the ID number',
    next: 'Next',
    submit: 'Submit',
    phoneReset: 'Phone number',
    emailReset: 'Email address',
    ResetLoginPassword: 'Reset password',
    ResetLoginPasswordError: 'It is forbidden to withdraw coins within 48 hours after resetting the login password',
    password: 'New password',
    passwordError: '8～20,+Please enter 8 to 20 digits, including numbers and letters',
    confrimPassWord: 'Confirm password',
    confrimPassWordError: 'The two new password entries are not the same',
    phone: 'Phone number',
    phoneError: 'The phone number input format is incorrect ',
    phoneCode: 'SMS verification code ',
    phoneCodeError: 'Please enter a 6-digit SMS verification code',
    email: 'Email address ',
    emailError: 'The email format is incorrect ',
    emailCode: 'Email verification code',
    emailCodeError: 'Please enter a 6-digit mailbox verification code ',
    resetSuccess: 'The password is reset successfully, please login',
    phoneSendSuccess: 'SMS has been sent, please check it ',
    emailSendSuccess: 'The email has been sent, please check it ',
  },
  // translate
  assets: {
    branchName: 'Chain name',
    hideMinAssets: 'Hide Minor Balances',
    suspend: 'Suspend',
    withdrawStop: 'Withdrawal suspend',
    depositStop: 'Deposit suspend',
    b2c: {
      otcShow: {
        header: 'OTC',
        fiatTitle: 'OTC Set reminder',
        leaglTenderSet: 'OTC Set',
        fiatdealTitle: 'OTC',
        goHall: 'Back',
        unEnough: 'OTC  Account Insufficient balance',
        otcAccount: 'OTC  Account',
        lagel: 'Fiat Currency',
        otcOrder: 'OTC Order',
        otcTradeWarning: 'To ensure the safety of funds, the purchased assets will be locked and can not be operated, such as withdrawing and OTC selling until 24 hours later. Meanwhile, transactions and other businesses will not be affected.',
      },
      lagel: 'Fiat Currency',
      allName: 'Full name',
      recrgeTitle: 'deposit account',
      rechargeSum: 'deposit amount',
      rechargeMin: 'Note: single deposit shall not be less than',
      voucherTit: 'Transfer voucher',
      voucherWarn: 'Upload your deposit record after offline transfer',
      voucherCli: 'Upload deposit voucher',
      bankName: 'Bank name',
      bankSub: 'branch',
      cardNo: 'Card number',
      name: 'Payee',
      remark: 'deposit notes',
      withdrawMin: 'minimum withdrawal amount',
      withdrawMax: 'Maximum withdrawal amount',
      withdrawDay: 'Today\'s withdrawal limit',
      withdrawAddress: 'withdraw account',
      fee: 'Fee',
      arrivalAccount: 'Amount received',
      withdrawMinWarn: 'Single withdrawal amount shall not be less than',
      withdrawMaxWarn: 'Single withdrawal amount shall not be greater than',
      withdrawDayWarn: 'Today\'s withdrawal limit',
      withdrawHaveWarn: 'Available balance is',
      addressMent: 'account management',
      addressAddTit: 'Add account',
      addressSetTit: 'Modify account',
      addressListTit: 'Account list',
      warning: 'Tips',
      deleteWarn: 'Delete',
      payType: 'Payment type',
      address: 'Account',
      addressUserName: 'Payee',
      bankCard: 'Bank card',
      set: 'Edit',
      firstWay: 'payment type',
      country: 'Bank',
      countrySub: 'branch',
      countryNo: 'Bank account',
      submit: 'Submit',
      b2cRecrgeHisList1: 'Number of applications',
      b2cRecrgeHisList2: 'Actual Amount Received',
      b2cRecrgeHisList3: 'Processing time',
      seePz: 'View voucher',
      b2cWithdrawHisList1: 'Amount received',
    },
    krw: {
      rechargeMin: 'The deposit amount is not less than',
      rechargeAccount: 'Deposit bank account',
      rechargeUserName: 'Bank account name',
      rechargeBankName: 'Bank name',
      rechargeBankAccount: 'Bank account number',
      rechargeSum: 'Deposit amount',
      rechargeConfrim: 'Deposit confirmation',
      rechargeTo: 'Deposit to the specified account',
      rechargeText: 'Transfer remarks content',
      copySuccess: 'Copy success',
      rechargeList1: 'Application time',
      rechargeList2: 'Time of arrival',
      rechargeList3: 'Currency',
      rechargeList4: 'Deposit amount',
      rechargeList5: 'Amount received',
      rechargeList6: 'Platform account',
      rechargeList7: 'State',
      rechargeListError: 'Not arrived',
      withdrawAccount: 'Withdrawal bank account',
      withdrawUserName: 'Bank account name',
      withdrawBankName: 'Bank name',
      withdrawBankAccount: 'Bank account number',
      withdrawFee: 'Withdrawal fee',
      withdrawNum: 'Total amount',
      withdrawAuth1: 'Mobile identity authentication or identity verification',
      withdrawAuth2: 'OTP verification',
      withdrawAuth3: 'Bind bank card',
      withdrawList1: 'Application time',
      withdrawList2: 'Time of arrival',
      withdrawList3: 'Currency',
      withdrawList4: 'Withdrawal amount',
      withdrawList5: 'Fee',
      withdrawList6: 'User bank account',
      withdrawList7: 'State',
      withdrawListError: 'Not arrived',
    },
    index: {
      title: 'Assets',
      overview: 'Overview',
      exchangeAccount: 'Spot Account',
      coExchangeAccount: 'Primary Account',
      addressMent: 'Address List',
      flowingWater: 'Trade History',
      otcAccount: 'Fait Account',
      otcFlowingWater: 'Fund statement',
      leverage: 'Margin Account',
      coAccount: 'Futures Account',
      bibaoAccount: 'BiBao Account',
      detail: 'View details',
    },
    leverageAccount: {
      find: 'Search',
      list1: 'Margin Account',
      list2: 'Total assets',
      list3: 'Available',
      list4: 'Freeze',
      list5: 'Lent',
      list6: 'Liquidation Price',
      list7: 'Risk rate',
      list8: 'Operating',
      transfer: 'Transfer',
      ToLoan: 'Loans',
    },
    leverageToLoan: {
      typeText1: 'Principal',
      typeText2: 'Interest',
      typeText3: 'Principal+Interest',
      title: 'Loans',
      can: 'Available',
      transfer: 'Transfer',
      warning: 'When the risk rate is ≤110%, the account will trigger a short position to return the borrowed funds.',
      max: 'Maximum amount',
      borrowed: 'Lent',
      rate: 'Interest rate',
      rateMark: 'The interest rate is the ratio of the interest charged by the system when applying for a loan. The interest is calculated according to the 24-hour interest rate.',
      number: 'Number of loans',
      ToLoan: 'Loans',
      listTitle: 'Recent loan record',
      list1: 'Application time',
      list2: 'Margin account',
      list3: 'Currency',
      list4: 'Quantity',
      list5: 'Interest rate',
      list6: 'Unpaid interest',
      list7: 'Unpaid quantity',
      list8: 'Operation',
      canToLoan: 'Can borrow',
      inputError1: 'The amount of borrowings must not be greater than the number of borrowables',
      inputError2: 'The amount of borrowings must not be less than',
      repayment: 'Return',
    },
    leverageTransfer: {
      title: 'Transfer of funds',
      leverageAccount: 'Margin Account',
    },
    leverageRepayment: {
      title: 'Return',
      symbol: 'Margin Account',
      coin: 'Return currency',
      Surplus: 'Amount to be returned',
      sum: 'Number of loans',
      rate: 'Interest',
      RepaymentNum: 'Return quantity',
      error1: 'The amount of return shall not be less than',
      error2: 'The returned quantity must not be greater than the available quantity',
      error3: 'The return quantity shall not be greater than the quantity to be repaid',
      can: 'Available',
    },
    lerverageFlowingWater: {
      direction: 'Direction',
      symbol: 'Margin Account',
      allCoin: 'All',
      directionAll: 'All',
      directionIn: 'Transfer to margin',
      directionOut: 'Transfer from margin',
      tab1: 'Current loan',
      tab2: 'Historical lending',
      tab3: 'Transfer record',
      tab1List1: 'Application time',
      tab1List2: 'Margin Account ',
      tab1List3: 'Coin',
      tab1List4: 'Quantity',
      tab1List5: 'Interest rate',
      tab1List6: 'Unpaid interest',
      tab1List7: 'Unpaid quantity',
      tab1List8: 'Operation',
      tab2List1: 'Application time',
      tab2List2: 'Margin Account',
      tab2List3: 'Coin',
      tab2List4: 'Quantity',
      tab2List5: 'Interest rate',
      tab2List6: 'Interest',
      tab2List7: 'Status',
      tab3List1: 'Time',
      tab3List2: 'Margin account',
      tab3List3: 'Coin',
      tab3List4: 'Quantity',
      tab3List5: 'Direction',
      repayment: 'Returned',
      status1: 'Loans',
      status2: 'Partial return',
      status3: 'Returned',
      status4: 'liquidation',
      status5: 'Over loss',
      status6: 'Liquidation finished',
      status7: 'Over Loss finished',
    },
    exchangeAccount: {
      positionBalance: 'Mining lock',
      incomeLock: 'Financial lock',
      positionV2Amount: 'Token lock',
      TotalAssets: 'Estimated Value',
      MyAssets: 'My Assets',
      ListOfFunds: 'Coin',
      HideZeroAssets: 'Hide zero assets',
      SearchCurrency: 'Search',
      coin: 'Coin',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Frozen ',
      AssetFolding: 'Estimated Value',
      options: 'Operation',
      other: 'Other ',
      Recharge: 'Deposit ',
      withdraw: 'Withdraw ',
      position: 'Lock Position',
      limit: 'limit',
      trade: 'Trade',
    },
    addressMent: {
      pageText: 'When depositing, you need to provide both a deposit address and a tag (Memo). The tag is a unique string of numbers that ensures the uniqueness of your deposit address and corresponds one-to-one with the deposit address. Please make sure to follow the correct deposit steps and enter complete information when withdrawing. Otherwise, it may result in loss of funds.',
      addAddress: 'Add address',
      coin: 'Coin',
      WithdrawalAddress: 'Withdrawal Address ',
      Remarks: 'Address Notes',
      label: 'Tag(Memo)',
      add: 'Add ',
      listCoin: 'Coin',
      listRemarks: 'Notes',
      listAddress: 'Address',
      listOptions: 'Operations',
      AddressList: 'Address List ',
      safetyWarning: 'Safety warning ',
      safetyWarningError: 'For the security of your account, please enable at least one verification method.',
      GotoOpen: 'Settings',
      safetyVerification: 'Security Verification ',
      phoneCode: 'SMS verification code ',
      phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
      googleCode: 'Google authentication code ',
      googleCodeError: 'Please enter a 6-digit Google verification code',
      bindGoogle: 'Bind Google Authentication',
      bindPhone: 'Bind Mobile Authentication',
      phoneSendSuccess: 'SMS has been sent, please check it',
      delete: 'Delete ',
      notSupport: 'Trading for this currency is not currently supported.',
    },
    flowingWater: {
      coin: 'Coin ',
      type: 'Type ',
      allCoin: 'All coins ',
      RechargeRecord: 'Deposit History',
      WithdrawalsRecord: 'Withdrawal History',
      OtherRecords: 'Other History',
      RechargeTime: 'Time ',
      RechargeCoin: 'Coin',
      RechargeVolume: 'Quantity',
      RechargeNumber: 'Confirmation times',
      RechargeStatus: 'Status',
      withdrawTime: 'Time ',
      withdrawAddress: 'Address ',
      withdrawVolume: 'Amount',
      withdrawFee: 'Fee ',
      withdrawRemarks: 'Notes',
      withdrawStatus: 'Status',
      withdrawOptions: 'Operation',
      otherTime: 'Time',
      otherCoin: 'Coin',
      otherType: 'Type',
      otherVolume: 'Amount',
      otherStatus: 'Status',
      withUser: 'Source user',
      rechargeAddress: 'Deposit Address',
      Cancel: 'Cancel ',
      label: 'Tag',
      updataAt: 'Wallet processing time',
      txid: 'Blockchain transaction ID',
      type1: 'External deposit',
      type2: 'Internal transfer',
    },
    recharge: {
      pageText: 'When depositing, you need to provide both a deposit address and a tag (Memo). The tag is a unique string of numbers that ensures the uniqueness of your deposit address and corresponds one-to-one with the deposit address. Please make sure to follow the correct deposit steps and enter complete information when withdrawing. Otherwise, it may result in loss of funds.',
      rechargeWarning: 'You must fill in the deposit address and tag when recharging. This is the unique identifier of your account. Failure to fill it in or fill in the wrong way will lead to the loss of your assets.',
      recharge: 'Deposit',
      rechargeError: 'Please do not deposit any non-native assets to the above address, otherwise the assets cannot be recovered.',
      minimumDepositAmount: 'Minimum deposit amount',
      depositcredited: 'Deposit credited',
      networkConfirmation: ' network confirmation(s)',
      rechargeAddress: 'Deposit Address ',
      label: 'Tag(Memo)',
      RecentRechargeRecord: 'Recent records',
      RechargeReminder: 'Tips',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Freeze ',
      RechargeTime: 'Time ',
      RechargeCoin: 'Coin',
      RechargeVolume: 'Amount',
      RechargeNumber: 'Confirmation times ',
      RechargeStatus: 'Status',
      copyAddress: 'Address copied successfully ',
      copyLabel: 'Tag(Memo) was copied successfully',
      notSupport: 'Deposits for this currency are currently not supported.',
    },
    withdraw: {
      pageText: 'When depositing, you need to provide both a deposit address and a tag (Memo). The tag is a unique string of numbers that ensures the uniqueness of your deposit address and corresponds one-to-one with the deposit address. Please make sure to follow the correct deposit steps and enter complete information when withdrawing. Otherwise, it may result in loss of funds.',
      withdraw: 'Withdraw ',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Freeze ',
      MinimumCoinLimit: 'Min Limit ',
      MaximumCoinLimit: 'Max Limit ',
      dayMaximumCoinLimit: 'Daily remaining limit',
      CoinAddress: 'Withdraw Address ',
      label: 'Tag(Memo)',
      NumberOfCoins: 'Amount',
      fee: 'Fee ',
      feeError: 'Please enter the correct fee',
      allWithdraw: 'Withdraw all ',
      buttonWithdraw: 'Withdraw',
      addAddrss: 'Add address',
      RecentWithdrawalRecords: 'Recent',
      safetyWarning: 'Tips',
      enforceGoogleAuth: 'For the security of your account, please enable security verification',
      safetyWarningError: 'For the security of your account, please enable at least one verification method',
      GotoOpen: 'Settings',
      safetyVerification: 'Security Verification ',
      phoneCode: 'SMS verification code ',
      phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
      googleCode: 'Google verification code ',
      googleCodeError: 'Please enter a 6-digit Google verification code',
      bindGoogle: 'Connect Google verification ',
      bindPhone: 'Connect mobile phone verification',
      withdrawTime: 'Time',
      withdrawAddress: 'Withdraw Address ',
      withdrawVolume: 'Amount',
      withdrawFee: 'Fee ',
      withdrawRemarks: 'Notes',
      withdrawStatus: 'Status',
      withdrawOptions: 'Operation',
      NumberOfCoinsError: 'Please enter the number of coins ',
      NumberOfCoinsError2: "The number of coins must be greater than the miner's fee",
      NumberOfCoinsError3: 'The number of coins cannot be greater than the available balance',
      NumberOfCoinsError4: '(Withdrawing amount - the fee) needs to be greater than the minimum withdrawal amount and less than the maximum withdrawal amount.',
      NumberOfCoinsError5: '(Number of coins- the fee) needs to be less than the current withdrawal',
      phoneSendSuccess: 'SMS has been sent, please check it',
      range: 'Range ',
      account: 'Reciprocal account(Phone/Email/UID)',
      innerList: 'Transfer records',
      transferTime: 'Transfer Time',
      transferNumber: 'Transfer amount',
      sideAccount: 'Reciprocal account',
      innerTranfer: 'Internal transfer',
      transfer: 'Transfer',
      notSupport: 'Withdrawals for this currency are currently not supported.',
    },
    otcAccount: {
      TotalAssets: 'Estimated Value',
      ListOfFunds: 'Coin',
      HideZeroAssets: 'Hide zero assets',
      SearchCurrency: 'Search',
      CapitalTransfer: 'Transfer',
      coin: 'Coins',
      Available: 'Available ',
      freeze: 'Freeze ',
      options: 'Operation',
      from: 'From ',
      to: 'Transfer to ',
      exchangeAccount: 'Spot Account',
      otcAccount: 'Fiat Account',
      all: 'All',
      volume: 'The number of transfers',
      volumeError: 'Available quantity is not enough',
      can: 'Can be transferred',
      other: 'Other ',
      optionCapitalTransfer: 'Capital Transfer',
    },
    otcFlowingWater: {
      title: 'History',
      type: 'Type',
      coin: 'Coin',
      all: 'All ',
      allCoin: 'All coins ',
      inOtc: 'Transfer in',
      outOtc: 'Transfer out',
      listTime: 'Time',
      listCoin: 'Coin',
      listType: 'Type',
      listVolume: 'Amount',
    },
    coAccount: {
      quota: 'Account Balance',
      transfer: 'Fund transfer',
      totel: 'Available Balance',
      accountRight: 'Account Equity',
      orderMargin: 'Order Margin',
      positionMargin: 'Position Margin',
      unrealisedAmount: 'Unrealized P/L',
      listTitle: 'Open contract',
      useMarginRate: 'Margin has been used',
      coAccount: 'Futures Account',
      list1: 'Futures',
      list2: 'Amount(cont) ',
      list3: 'Realized P/L',
      list4: 'Unrealized P/L',
      list5: 'Operation',
      type1: 'Perpetual',
      type2: 'This Week',
      type3: 'Next Week',
      type4: 'Monthly',
      type5: 'Quarterly',
    },
    coFlowingWater: {
      list1: 'Time',
      list2: 'Type',
      list3: 'Quantity',
      list4: 'Symbol',
      list5: 'Futures Account',
    },
    bibaoAccount: {
      bibaoAccount: 'BiBao Account',
      coin: 'Coin',
      lumpSum: 'Total',
      quota: 'Balance',
      bibao: 'BiBao',
      opera: 'Operation',
      transfer: 'Transfer in',
      detail: 'Details',
      bibaoDetail: 'View details',
      transferNum: 'Transfer in amount',
      freed: 'Release',
      startTime: 'Start time',
      endTime: 'Due time',
      status: 'Status',
    },
  },
  // translate
  order: {
    index: {
      title: 'Order Center',
      exOrder: 'Spot Order',
      otcOrder: 'Fiat Order',
      leverage: 'Margin Order',
    },
    exchangeOrder: {
      all180: 'All (last 180days)',
      haveCancel: 'Cancelled Order',
      type: 'Type',
      symbol: 'Pair',
      market: 'Markets',
      coin: 'Pair',
      nowOrder: 'Open Order',
      hisOrder: 'Order History',
      all: 'All ',
      buy: 'Buy ',
      sell: 'Sell ',
      nowOrderTime: 'Time',
      nowOrderType: 'Type',
      nowOrderPrice: 'Price',
      nowOrderVolume: 'Amount',
      nowOrderTotol: 'Total',
      nowOrderAverage: 'Average Price',
      nowOrderTransaction: 'Executed/Unexecuted',
      nowOrderOptions: 'Operation',
      hisOrderTime: 'Time',
      hisOrderType: 'Type',
      hisOrderPrice: 'Price',
      hisOrderVolume: 'Amount',
      hisOrderAverage: 'Average Price ',
      hisOrderStatus: 'Status',
      hisOrderOptions: 'Operation',
      marketPrice: 'Markets',
      cancel: 'Cancel ',
      details: 'Details ',
      detailsTime: 'Time',
      detailsPrice: 'Price',
      detailsVolume: 'Amount',
      detailsTotol: 'Turnover',
      detailsFee: 'Fee',
    },
    otcOrder: {
      haveCancel: ' Show cancelled orders',
      coin: 'Coin',
      allCoin: 'All',
      nowOrder: 'Open Order',
      hisOrder: 'Order History',
      all: 'All',
      buy: 'Buy',
      sell: 'Sell',
      nowOrderId: 'No.',
      nowOrderType: 'Side',
      nowOrderCoin: 'Coin',
      nowOrderPirce: 'Price',
      nowOrderVolume: 'Amount',
      service: 'fee',
      nowOrderTotol: 'Transaction amount',
      nowOrderStatus: 'Status',
      nowOrderUser: 'Conterparty',
      hisOrderId: 'No.',
      hisOrderType: 'Side',
      hisOrderCoin: 'Coin',
      hisOrderPirce: 'Price',
      hisOrderVolume: 'Amount',
      hisOrderTotol: 'Transaction amount',
      hisOrderStatus: 'Status',
      hisOrderUser: 'Conterparty',
    },
    coOrder: {
      coOrder: 'Futures Order',
      type: 'Type',
      contract: 'Futures',
      nowList1: 'Time',
      nowList2: 'Futures',
      nowList3: 'Quantity(cont)',
      nowList4: 'Order Price',
      nowList5: 'Filled',
      nowList6: 'Remaining',
      nowList7: 'Order Value',
      nowList8: 'Average Price',
      nowList9: 'Type',
      nowList10: 'Status',
      nowList11: 'Futures',
      hisList1: 'Time',
      hisList2: 'Futures',
      hisList3: 'Quantity(cont)',
      hisList4: 'Order Price',
      hisList5: 'Filled',
      hisList6: 'Average Price',
      hisList7: 'Type',
      hisList8: 'Status',
      status1: 'New Order',
      status2: 'Complete Deal',
      status3: 'Partial Deal',
      status4: 'Cancelled',
      status5: 'Revoked',
      status6: 'Deprecated',
      status7: 'Partial transaction has been revoked',
      orderType1: 'Perpetual',
      orderType2: 'This Week',
      orderType3: 'Next Week',
      orderType4: 'Monthly',
      orderType5: 'Quarterly',
      infoOrder: 'Limit',
      marketOrder: 'Markets',
      cancel: 'Cancel order',
    },
  },
  // translate
  otcRelease: {
    title: 'Publish a trading ad ',
    text1: 'If you trade this currency frequently, you can post your own trading ad. If you only want to buy or sell once, we recommend you to place an order directly from the purchase or sale list.',
    text2: 'If you post a sale ad, please ensure that your account balance is sufficient.',
    text3: 'The user who publishes the transaction advertisement needs to pay a part of the fee for each completed transaction; the specific cost is subject to actual conditions',
    text4: 'According to the market price, the transaction price can be flexibly changed according to the market conditions, and the fixed price cannot be changed.',
    text5: 'We suggest you to communicate about all matters only on this site to avoid unnecessary risks',
    type: 'Type',
    buy: 'Buy ',
    sell: 'Sell ',
    currency: 'Currency type',
    currencyError: 'Please select currency type',
    countryType: 'Country/Region for Order Service',
    countryError: 'Select the Country/Region for order services',
    volume: 'Available',
    Surplus: 'Surplus',
    CurrentUnitPrice: 'Reference price',
    ReferenceWebSite: 'Reference Website',
    PricingMethod: 'Pricing Method',
    PricingMethodError: 'Please select currency type',
    CustomPrice: 'Custom Price',
    TotalSum: 'Total',
    MinimumQuota: 'Min Limit',
    MaximumQuota: 'Max Limit',
    min: 'Minute',
    TimeLimitForPayment: 'Time Limit for the Payment ',
    MinimumNumber: 'The minimum number of transactions of the other party',
    frequency: 'Frequency',
    FailureTime: 'Failure Time',
    FailureTimeError: 'Please select the failure time',
    PaymentMethod: 'Payment method ',
    PaymentMethodWarning: 'Select up to 3 payment methods',
    Receivables: 'Receipt method',
    ReceivablesWarning: 'You can choose several payment methods',
    PaymentError: 'You haven\'t added a receiving method yet, please go to the personal center to set it up.',
    AutomaticRecovery: 'Automatic Recovery (Optional)',
    AdvertisingMessage: 'Advertising message (Optional)',
    submit: 'Create ad',
    Reminder: 'Reminder',
    AnotherOne: 'Send another one',
    goHall: 'Return to the advertising hall',
    success: 'Congratulations, the ad was successfully published',
    SafetyTips: 'Safety Tips',
    MarketPrice: 'Market Price (premium) ',
    Custom: 'Custom ',
    PleaseEnterQuantity: ' Please enter the quantity',
    availableBalance: 'Available balance is not enough',
    minPriceError1: 'The minimum limit cannot be greater than the total amount',
    minPriceError2: 'The minimum limit cannot be greater than or equal to the maximum limit',
    maxPriceError1: 'The maximum limit cannot be greater than the total amount',
    maxPriceError2: 'The maximum limit cannot be less than or equal to the minimum limit',
    paymentTimeLimit: 'Please enter the payment time limit',
    paymentTimeError: ' The payment time limit should be 10-20 minutes',
    jurisdictionTitle: 'Please complete the identity vertification, set up the nickname first, then you can publish the advertisement',
    jurisdictionTitle2: 'Please complete the identity vertification, set up the nickname and apply to become a merchant to post ads',
    authentication: 'identity verification',
    DeCertification: 'Go to verificate',
    SetNickname: 'Set up the nickname',
    ToSetUp: 'Go to settings',
    ApplicationMerchant: 'Merchant Application',
    ToApply: 'Go to apply',
    threePayment: 'You can choose up to three payment methods',
    day: 'Day ',
    higher: 'Above the reference price',
    lower: 'Below the reference price',
    precent: 'Premium price',
    des: "Comprehensive references on the mainstream exchange and Stock quotes' real-time exchange rate, Update at regular time",
    precentWay: 'Premium direction',
    precentError: 'The premium price shall not be greater than 50.00%',
  },
  // translate
  otcTrade: {
    warning: 'In order to ensure the security of the funds, the purchased assets will be locked for 24 hours before withdrawal is allowed but trading will not be affected.',
    inLine: 'Online',
    outLine: 'Offline',
    TransactionTimes: 'Number of transactions',
    CreditDegree: 'Credit',
    his: 'Transaction history(equivalent to BTC)',
    price: 'Price ',
    volume: 'Amount ',
    TradingLimit: 'Limit ',
    TimeLimitPayment: 'Payment time limit ',
    MerchantRemarks: 'Merchant Remarks ',
    min: 'Minute',
    closeTitle: 'Close the ad',
    closeWarning: 'If you close the ad, you will not be able to make transactions in the future. Are you sure you want to close this ad ',
    goHall: 'Return',
    close: 'Close ad',
    PurchaseAmount: 'Purchase Amount ',
    AmountSale: 'Sale amount ',
    all: 'All ',
    pass: 'Fund password ',
    passError: ' Please enter 8 to 20 digits, including numbers and letters',
    ImmediateSale: 'Sale immediately',
    ImmediatePurchase: 'Buy now',
    CountDown: 'Countdown',
    numberError: 'The order amount is greater than the order quantity',
    numberMinError: 'The number of exchanges must not be less than the minimum transaction limit',
    numberMaxError: 'The number of exchanges must not be greater than the maximum transaction limit',
    OrderAmount: 'Order amount',
    ScopeOrderAmount: 'Order amount range',
    QuantityInExchange: 'Exchange Quantity',
    use: 'Use',
    sell: 'Sell',
    buy: 'Buy',
    TransactionMode: 'Transaction Mode ',
    payment: 'payment method',
    Receivables: 'Receipt method',
    none: 'None',
  },
  // translate
  otcDetailOrder: {
    noPaymentErr: 'Please select payment method',
    addPaymentErr: 'Please add payment method first',
    goPay: 'Go to pay',
    CancellationOrder: 'Cancel the order',
    WaitingPayment: 'Awaiting Buyer’s Payment',
    WaitingPuttingMoney: 'Awaiting Seller’s Release',
    ConfirmReleaseMoney: 'Confirm receipt and release coin',
    SubmitAcomplaint: 'Appeal',
    goHall: 'Return to OTC hall',
    OrderClosed: 'Order closed',
    OrdersAppeal: 'Order appeal',
    CancellationComplaint: 'Cancel the complaint',
    OrderException: 'Order Exception ',
    ConfirmPayment: 'Confirm the payment ',
    MarkedAsPaid: 'Marked As Paid ',
    NotYetPaid: 'Not Yet Paid ',
    payWarning: 'This platform does not support automatic money deduction, please transfer money yourself to the above account',
    PaymentAmount: 'Payment Amount',
    PaymentReference: 'Payment Reference Number',
    Otherparty: 'Other party',
    ConfirmReleaseMoneyTitle: 'Cancel Order',
    ConfirmReleaseMoneyWarning: 'Please be sure to Login and confirm the receipt of the payment',
    pass: 'Fund password',
    passError: 'Please enter 8 to 20 digits, including numbers and letters',
    ConfirmReleaseMoneyConfrim: 'I confirm that I have logged in to my payment account and checked the payment is correct',
    CancellationOrderTitle: 'Cancel the order',
    CancellationOrderWarning1: 'No refund will be given after canceling the order. If you have already paid, please do not cancel the order.',
    CancellationOrderWarning2: 'Cancellation Rule: If the buyer cancels 3 orders in total on one day, it will lead to the limit of the buying functions on that day',
    CancellationOrderConfrim: 'I confirm that I have not paid to the other party yet',
    AppealTitle: 'Appeal',
    AppealWarning: 'If the order encounters a dispute, it can be solved through the appeal channel.',
    ReasonsAppeal: 'Appeal reason',
    CancellationComplaintTitle: 'Cancel the appeal',
    CancellationComplaintConfrim: 'Cancel the complaint on your behalf without dispute. Do you want to confirm to cancel the complaint?',
    AppealTitleFive: 'The appeal can only be submitted 5 minutes after payment confirmation.',
    PendingPayment: 'Awaiting Buyer’s Payment',
    CountdownPayments: 'Payment Countdown ',
    WaitingCountdownPayment: 'Awaiting Buyer’s Payment.  Countdown',
    MoneyCollected: 'Awaiting Seller’s Release ',
    MoneyCollectedWarning: 'After seller confirms the payment and releases the currency, you will receive the corresponding amount. ',
    otherPartyPaid1: 'Buyer Has Paid',
    otherPartyPaid2: 'Marked as',
    otherPartyPaid3: 'Payment Successful',
    Completedbuy1: 'Order Completed',
    Completedbuy2: 'You can through',
    Completedbuy3: 'View assets',
    Completedbuy4: 'Transfer to the Spot account for trading',
    CoCompletedbuy4: 'Transfer to the primary account for trading',
    Completedsell: 'Order Completed',
    TitleOrderClose: 'Order closed',
    TitleOrderClose_buyer: 'Buyer cancelled, order closed',
    TitleOrderClose_timeout: 'Timeout, order closed',
    TitleComplaint: 'Appealing',
    TitleComplaintText: 'Our customer service staff is actively working for you. Please be patient and wait for the results.',
    TitleOrderException: 'Order exception',
    AfterAppealbuy1: 'Order Completed',
    AfterAppealbuy2: 'You can pass',
    AfterAppealbuy3: 'View assets',
    AfterAppealbuy4: 'Transfer to the Spot account for trading',
    CoAfterAppealbuy4: 'Transfer to the primary account for trading',
    AfterAppealsell: 'Order Completed',
    barText: 'Has been ordered',
    bar1Buy1: 'Awaiting Buyer’s Payment',
    bar1Buy2: 'Awaiting Seller’s Release',
    bar1Sell1: 'Awaiting Buyer’s Payment',
    bar1Sell2: 'Awaiting Seller’s Release',
    bar2Buy1: 'Buyer Has Paid',
    bar2Buy2: 'Awaiting Seller’s Release',
    bar2Sell1: 'Payment received',
    bar2Sell2: 'Awaiting Seller’s Release',
    bar3Buy1: 'Buyer Has Paid',
    bar3Buy2: 'Seller Has Released',
    bar3Sell1: 'Payment received',
    bar3Sell2: 'Seller Has Released',
    bar4Sell: 'Closed',
    bar5Sell: 'Appealing',
    bar7Sell: 'Exception Order',
    bar8Buy1: 'Buyer Has Paid',
    bar8Buy2: 'Seller Has Released',
    bar8Sell1: 'Payment received',
    bar8Sell2: 'Seller Has Released',
    day: 'Day',
    hour: 'Hour',
    min: 'Minute',
    sec: 'Seconds',
    SellersPaymentMethod: "Seller's payment method",
    paysBuy2: "You have paid, you can't view the other party's payment information",
    paysBuy3: "You have paid, you can't view the other party's payment information",
    paysSell3: 'Order has been completed, unable to view payment information',
    pays4: 'The order has been closed, unable to view payment information',
    pays5: 'The order is in the process of appealing, unable to view payment information',
    pays7: "The order is abnormal, can't view payment information,",
    paysBuy8: "You have paid, you can't view the other party's payment information",
    paysSell8: 'Order has been completed, unable to view payment information',
    MessPaymentReference: 'Payment Reference Number',
    MessPrice: 'Unit price',
    MessVolume: 'Amount',
    MessTotol: 'Total price',
    MessMerchantRemarks: 'Merchant Remarks',
    none: 'None',
    chatServer: 'Customer service',
    chatUser: 'Merchant',
    chatServerMessage: 'System Message: You have successfully submitted your appeal, please be patient.',
    chatServerInp: 'Please enter information',
    chatServerBut: 'Send',
    inline: 'Online',
    outline: 'Offline',
    chatVolume: 'Volume',
    chatUserInp: 'Please enter information',
    chatUserBut: 'Send',
    identification: 'identity information',
    connection: 'Contact information',
    phone: 'Phone number',
    twoMin: 'The buyer can check it in 2 minutes after payment.',
  },
  // translate
  components: {
    alert: {
      buttonText: 'I understood',
    },
    dialog: {
      confirmText: 'Confirm ',
      closeText: 'Cancel',
    },
    getCode: {
      button: 'Get code',
      after: 'Get it again',
    },
    select: {
      noData: 'No data',
    },
    otcReminder: {
      title: 'Reminder',
      text1: '1.Please do not include any information such as BTC, USDT, platform information, or digital currency information in the remarks during the transfer process to prevent your remittance from being intercepted, your bank card from being frozen, and other issues that may cause a delay in the arrival of funds. In such cases, the seller may choose to reject the transaction.',
      text2: '2.Please use a bank card, Alipay or payment method that is verified with your real name on the platform for transfer. Otherwise, the seller may refuse to complete the transaction and file a appeal.',
      text3: '3.If the transaction amount exceeds 50,000 CNY, remittances to a bank account after 5:00 PM on a legal holiday or workday may result in delayed arrival. Please split the payment to ensure timely arrival. If the payment does not arrive in time, the seller has the right to refuse the transaction.',
      text4: '4.If you have completed your payment, be sure to click the "I have paid" button and the seller will receive the digital asset upon confirmation of the payment.',
    },
  },
  manageFinances: {
    manage_finances: 'Financial treasure',
    subTitle: 'Automatic diversification of investment tools, saving time and effort',
    record: 'Financial records',
    day: 'Day',
    recommend: 'Recommended',
    safe: 'Security',
    expected: 'Expected',
    rate: 'The yield',
    timeLimit: 'Time limit',
    people: 'm',
    join: 'The cumulative join',
    now: 'Earn now',
    yearRate: 'Annual',
    dayRate: 'Daily',
    moreProducts: 'See more products',
    Repayment: 'Repayment methods',
    ReleaseCycle: 'Release cycle',
    deadline: 'Project deadline',
    startTime: 'Start time for counting interest',
    exitTime: 'Exit time',
    times: 'Time',
    availableBalance: 'Available balance',
    goRecharge: 'Deposit',
    buyNumber: 'Purchase quantity',
    feature: 'Your expected earnings',
    commonProblem: 'Common problems',
    buyNow: 'Buy now',
    what: 'What is a treasure?',
    what_1: 'What is BitMore?',
    how: 'How to participate?',
    rule: 'Return rules for wealth management products?',
    rule_1: 'BitMore return rule?',
    forSafe: 'To ensure the security of your account, please complete the real-name verification first.',
    goAuth: 'To verify',
    note1: 'Financial treasure, launched by biki platform, is a fixed cycle financial coin product based on digital assets. Each plan has corresponding lock-in period and expected annual income, you can buy according to different needs. The principal will be locked after purchase and interest will be calculated from the agreed time. When the plan expires, the principal and income are unfrozen and transferred to the account, and you get the agreed income..',
    note1_1: 'Bitmore, launched by WBFex platform, is a fixed cycle financial coin product based on digital assets. Each plan has corresponding lock-in period and expected annual income, you can buy according to different needs. The principal will be locked after purchase and interest will be calculated from the agreed time. When the plan expires, the principal and income are unfrozen and transferred to the account, and you get the agreed income..',
    note2: 'Log into the official website of Biki digital asset exchange www.biki.com, click "go to finance" button in asset management, select the product you need according to your own situation, enter the amount of bitcoin, and click "join now" to participate in wealth management.',
    note2_1: 'Log into the official website of WBFex Digital Asset Exchange new.WBFex.com, click on the "go to finance" button in asset management, select the products you need according to your own situation, enter the number of currencies, click "join immediately" to participate in BitMore',
    note3: 'According to the rule of paying interest first and then principal, the first return period is three weeks in the product lock-in period, three times of interest will be returned after three weeks, and then the interest will be returned once a week, and the principal will be returned after the product expires.',
    inputNumber: 'Please enter the purchase quantity',
    buyNumMax: 'The purchase quantity shall not exceed the available balance',
    first: 'Interest first and then principal',
    together: 'Principal and interest together',
    buyTime: 'Buy time',
    name: 'The project name',
    orderNumber: 'The order number',
    coin: 'Coin',
    number: 'The number of',
    tablerate: 'Interest rate (%)',
    status: 'State',
    operating: 'Operation',
    transferTime: 'Return Time',
    returnCoin: 'Return the currency',
    returnNumber: 'Return the number of',
    type: 'Type ',
    allType: 'All types of',
    subscribed: 'Have subscribed',
    interested: 'Accruing interest',
    completed: 'Has been completed',
    interest: 'Interest',
    principal: 'The principal',
  },
  footer: {
    terms: 'Terms',
    agreement: 'Terms of Service',
    declaration: 'Legal Notices',
    aboutChainup: 'About',
    utils: 'Tool',
    about: 'About us',
    apply: 'Listing application',
    download: 'APP Downloads',
    api: 'API documentation',
    media: 'Social media',
  },
  appDownLoad: {
    text1: 'Download for Android',
    text2: 'Android APK',
    text3: 'Google Play',
    text4: 'Download now',
    text5: 'Download Link',
    text6: 'Download for IOS',
    text7: 'App Store',
    text8: 'TestFlight',
    text9: 'see more',
    title: 'Mobile App Download',
    desc: 'Multi-Platform Terminal Trading at Anytime and Anywhere',
    platform: [
      'iPhone',
      'Android',
    ],
    twoDimension: 'Scan QR code to download',
    headerCode: 'Scan QR code to download',
    moreDown: 'More downloads',
    flag: [
      {
        title: 'Flash Trades',
        desc: 'The platform provides a more convenient trading experience, including a variety of transaction types, quick order matching and one click trading.',
      },
      {
        title: 'Easy transfer of assets',
        desc: 'Easily transfer assets in your account, real-time digital asset overview, and currency ratio pie chart',
      },
      {
        title: 'Custom trading panel',
        desc: 'Freely define trading layout according to different trading habits, including K line and depth chart entry',
      },
      {
        title: 'Account integrated management',
        desc: 'An account with multiple security verifications and multiple currencies',
      },
    ],
    setUp: {
      title: 'iOS user installation tutorial',
      step: [
        {
          step: 1,
          title: 'App Download ',
          desc: 'Open the settings function in your phone and select "General";',
        },
        {
          step: 2,
          title: 'Equipment management',
          desc: 'In General, select the "Profile and Device Management" feature;',
        },
        {
          step: 3,
          title: 'Choose to install',
          desc: 'In the enterprise-level application category in the description file and device management, select the file name of the enterprise application to be installed (consistent with the prompt when opening), and click to enter;',
        },
        {
          step: 4,
          title: 'Set trust',
          desc: 'After entering the company signature page, after confirming the company name and application name in the company signature, click Trust "Enterprise Signature Company Name";',
        },
        {
          step: 5,
          title: 'Launch the app',
          desc: 'Go back to the desktop and re-open the app to use it.',
        },
      ],
    },
    setUpTestFlignt: {
      title: 'iOS user installation tutorial',
      step: [
        {
          step: 1,
          title: 'App Download ',
          desc: 'Click [Install TestFlight] and follow the instructions to open the APP Store to download TestFlight.',
        },
        {
          step: 2,
          title: 'TestFlight Download',
          desc: 'You can also download TestFlight directly from the App Store if you have already downloaded it, please ignore.',
        },
        {
          step: 3,
          title: 'Choose to install',
          desc: 'Open TestFlight APP to accept the Cobidex Beta version to open; if you have already downloaded it for [Update] to get the latest version.',
        },
      ],
    },
    download_text_1: 'IOS Download',
    download_text_2: 'Android APK',
    download_text_3: 'TestFlight',
    download_text_4: 'Google Play',
  },
  homeTemplate: {
    text_01: 'Multi-Platform Terminal Trading at Anytime and Anywhere',
    text_02: 'Covers multiple platforms of iOS, Android, Windows, Mac, and supports full business functions',
    text_03: 'Download apps',
    text_04: 'Products and Services',
    text_05: 'Secure, trusted digital asset trading and asset management services to millions of users worldwide',
    text_06: 'Globalization layout',
    text_07: 'Establishing localized transaction service centers in multiple countries to create multi-services',
    text_08: 'Security system',
    text_09: 'A top-notch team creates a professional and secure platform with multiple layers of defense to ensure your assets are worry-free.',
    text_10: 'Trading System',
    text_11: 'Establishing localized transaction service centers in multiple countries to create multi-services',
    text_12: 'High scalability',
    text_13: 'Quick asset circulation and smooth trading without obstacles',
    text_14: 'Start your trading journey now',
    text_15: 'Provide comprehensive digital asset services such as spot trading, fiat trading, and futures trading.',
    text_16: 'Sign up now',
    text_17: 'Multi-platform terminal trading',
    text_18: 'The Digital Assets steward beside U!',
    text_19: 'Get started now',
    text_20: 'Register',
    text_21: 'Email Address / Phone Number',
    products: {
      text_1: 'Core Products',
      text_2: 'All you need in one stop',
      text_3: 'Futures Trading',
      text_4: 'Support USDT perpetual contracts, long and short positions open at will, take profit at any time',
      text_5: 'Spot Trading',
      text_6: 'Support 100+ cryptocurrency trading, simple and convenient operation',
      text_7: 'Buy Crypto',
      text_8: 'Deposit cryptocurrency, start trading immediately, support multiple payment methods',
      text_9: 'Trade Now',
    },
    steps: {
      text_1: 'Start Trading',
      text_2: 'Start your trading journey now',
      text_3: 'Register',
      text_4: 'Register a account anytime, anywhere',
      text_5: 'Deposit',
      text_6: 'Deposit cryptocurrency into your account, support multiple deposit methods',
      text_7: 'Identity verification',
      text_8: 'Complete the Identity verification to protect your account assets',
      text_9: 'Ready to go, enjoy your cryptocurrency trading journey!',
    },
    services: {
      text_1: 'Products and Services',
      text_2: 'Secure,trusted digital asset trading and asset management services to millions of users worldwide',
      text_3: 'Top-tier trading system',
      text_4: 'Global technology team with distributed parallel technology and high-speed matching engine, ensuring a smooth trading experience.',
      text_5: 'Top-notch risk control escort',
      text_6: 'Leading risk control system in the industry ensures asset security without worries',
      text_7: 'Rich product features',
      text_8: 'High-leverage futures, multi-currency spot trading, fast deposits and withdrawals.',
      text_9: 'Excellent customer service',
      text_10: 'Multilingual, multi-channel service system, ready to answer your questions at any time.',
    },
    text_22: 'Trade Now',
    text_23: 'Complete registration instantly to start your trading',
    footer: {
      title_1: 'About Us',
      title_2: 'Help',
      title_3: 'Service',
      title_4: 'Products',
      text_1_1: 'About exchange',
      text_1_2: 'Announcement',
      text_1_3: 'User Agreement',
      text_1_4: 'Privacy Policy',
      text_1_5: 'Risk Warning',
      text_1_6: 'Disclaimers',
      text_2_1: 'Help Center',
      text_2_2: 'Fee Schedule',
      text_2_3: 'Contract Guide',
      text_3_1: 'Online Customer Service',
      text_3_2: 'Submit a Ticket',
      text_3_3: 'Listing Application',
      text_3_4: 'Merchant Application',
      text_3_5: 'Downloads',
      text_4_1: 'Spot',
      text_4_2: 'Futures',
      text_4_3: 'Buy Crypto',
    },
    text_24: 'Covers multiple platforms of iOS, Android, and supports full business functions',
  },
  // translate
  lever: {
    leverAccount: 'Margin assets',
    leverKy: 'Available',
    leverKj: 'Can borrow',
    leverYj: 'Lent',
    leverjd: 'Loans',
    fxl: 'Risk rate',
    leverText1: 'Total assets/Loan assets*100%',
    leverText2: 'When the risk rate is ≤110%, the account will trigger a short position to return the borrowed funds.',
    bcj: 'Liquidation Price',
    leverHz: 'Transfer',
    leverJd: 'Loans',
    leverZded: 'Maximum amount',
    leverLl: 'Interest rate',
    all: 'All',
    leverJdcc: 'Successful loan',
    leverJdNumber: 'Number of loans',
    buy: 'Buy long',
    sell: 'Close short',
    alertTitle: 'Tips',
    your: 'Your',
    alertTet: 'Insufficient balance in your Margin account. Please transfer funds to your account before margin trading',
    hzBtntext: 'Transfer now',
  },
  contract: {
    co: 'Futures',
    co2: 'Futures',
    contractType1: 'Perpetual',
    contractType2: 'This Week',
    contractType3: 'Next Week',
    contractType4: 'Monthly',
    contractType5: 'Quarterly',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    H_volume: '24H Volume',
    handicap: 'Orderbook',
    latestDeal: 'Last trades',
    number: 'Amount',
    price: 'Price',
    total: 'Total',
    time: 'Time',
    volume: 'Volume',
    addEnsure: 'Increase Margin',
    minusEnsure: 'Reduce Margin',
    fqEnsure: 'Allocated Margin',
    kyEnsure: 'Available Margin',
    addMinusEnsure: 'Increase & Decrease margin',
    addEnsureNumbere: 'Increase Margin Amount',
    minusEnsureNumbere: 'Reduce Margin Amount',
    infoOrder: 'Limit order',
    marketOrder: 'Market order',
    cancel: 'Cancel',
    closePrice: 'Market price closing',
    limitPrice: 'Limit price closing',
    contractId: 'Futures ID',
    accountId: 'Position ID',
    coNumber: 'Number of Positions',
    Piece: 'Cont',
    holding: 'Open Positions',
    currentEntrust: 'Open order',
    dayTrading: 'Fills',
    historyEntru: 'Order History',
    nowList1: 'Time',
    nowList2: 'Futures',
    nowList3: 'Size',
    nowList4: 'Order Price',
    nowList5: 'Filled',
    nowList6: 'Remaining',
    nowList7: 'Value',
    nowList8: 'Average Price',
    nowList9: 'Type',
    nowList10: 'State',
    nowList11: 'Operation',
    nowList12: 'Filled price',
    nowList13: 'Opening price',
    nowList14: 'Mark price',
    nowList15: 'Liquidation Price',
    nowList16: 'Unrealized PNL',
    nowList17: 'Realized PNL',
    nowList18: 'ROE',
    nowList19: 'Margin',
    nowList20: 'Order ID',
    status1: 'New Order',
    status2: 'Filled',
    status3: 'Partially filled',
    status4: 'Cancelled',
    status5: 'Revoked',
    status6: 'Deprecated',
    status7: 'Partial-filled has been revoked',
    c_success: 'Order successfully',
    cancel_success: 'Cancel successfully',
    c_error: 'Operation failed',
    cost: 'Cost',
    orders: 'Order Value',
    balance: 'Available Balance',
    entryPrice: 'Opening price',
    liquidationPrice: 'Liquidation Price',
    bjPrice: 'Mark Price',
    liquidationPriceTwo: 'Estimated Liquidation Price',
    Value: 'Value',
    Chiccw: 'Your Position',
    Multipleb: 'Leverage',
    marketPrice: 'Market Price',
    cw: 'Position',
    rate: 'ROE',
    buyButton: 'Open long',
    sellButton: 'Open short',
    loginReg: 'Log In/Sign up',
    buy: 'Buy',
    sell: 'Sell',
    errorText_01: 'The maximum number of positions can be entered',
    errorText_02: 'The minimum number of positions can be entered',
    limitPriceTrade: 'Limit price',
    marketPriceTrade: 'Market price',
    piece: 'Cont',
    value: 'Value',
    chiccw: 'Your Position',
    multipleb: 'Leverage',
    deliveryTime: 'Time left for delivery',
    day: 'Day',
    success: 'Successful',
    pleprice: 'Please enter the closing price',
    closeToMark: 'The trigger price is too close to the mark price, and the order has failed.',
  },
  tradeLimt: {
    tradeLimit_text_everyDayCount: 'The currency pair limits the number of daily transactions,',
    tradeLimit_text_everyDayBuy: 'The maximum purchase amount per day is:',
    tradeLimit_text_everyDaySell: 'The maximum selling amount per day is:',
    tradeLimit_text_noLimitBuy: 'Unrestricted buy transaction',
    tradeLimit_text_noLimitSell: 'Unrestricted sell transaction',
    tradeLimit_text_instructions: 'Trading instructions',
    tradeLimit_text_everyDayBuy_end: ' ',
    tradeLimit_text_everyDaySell_end: ' ',
  },
  market: {
    allMarket: 'Market',
    text1: 'Overview',
    text2: 'Trade',
    text3: 'Basic information',
    vol: 'Vol',
    noDataDesc: 'No Favorites, go to the market to add',
    noData: 'No Data',
    addFavorites: 'Add Favorites',
    exchange: 'Spot',
    futures: 'Futures',
  },
  kyc: {
    success: 'Submission succeeded',
    error: 'Authentication failed!',
    text1: 'Failed to verify, please return to the personal settings to resubmit real-name verification.',
    text2: 'The account already has real-name authentication information and cannot submit another real-name application',
    text3: 'The verified real name information can not be verified repeatedly.',
    text4: 'Your information has been submitted will take 1min to review.  Please check the result on the user center.',
  },
  weeks: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  },
  months: {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
  },
  mobilityTrade: {
    addPrice: 'Please enter the amount',
    addVolume: 'Please enter the quantity',
    priceSell: 'Sold by amount',
    smallAmount: 'Small amount 0 transaction fee',
    tradeType: 'Type',
    immediately: 'One-click buy coins',
    immediatelyBuy: 'One-click buy',
    immediatelySell: 'One-click sell',
    priceBuy: 'Purchase by amount',
    volumeBuy: 'Buy by quantity',
    volumeSell: 'Sell by quantity',
    referencePrice: 'Reference  price',
    referenceWarn: 'Price is reference only. The price is calculated by the mainstream currency of the exchanges. ',
    coin: 'Currency',
    legal: 'Fiat currency',
    all: 'All',
    buyPayments: 'Choose payment method',
    sellPayments: 'Choose receiving method',
    addPayments: 'Add a receiving method',
    noPayments: "If there's no receiving method, please visit Me to setup.",
    tradePrice: 'Unit price',
    tradeVolume: 'Quantity',
    tradeSum: 'Actual Payment',
    warn: 'Due to market fluctuations the price may be slightly fluctuated. Please place your order ASAP to lock the price.',
    btnHis: 'Quote has expired, Please click to get the latest price',
    warn1: 'Enter the purchase amount ',
    warn2: 'Enter the purchase quantity',
    warn3: 'Enter the sell amount ',
    warn4: 'Enter the sell quantity',
    error1: 'The maximum order amount ',
    error2: 'The range of order amount',
    error3: 'The maximum order quantity ',
    error4: 'The number of orders placed',
    error5: 'No suitable quotation found, please modify the order conditions',
    error6: 'Please add the payment method first.',
  },
  freeStaking: {
    incomeFilter: [
      'Earnings credited ',
      'Principal locked',
      'Principal released',
    ],
    home: {
      status: [
        'Pending',
        'Locking',
        'Pending interest',
        'Calculating interest',
        'Finished',
        'Principal release',
        'Fulfilled the quota',
        'Finished',
      ],
      notice: 'View Announcement',
      title: 'Staking',
      gainRate: 'Annualized returns',
      lockDay: 'Locking period',
      lockProgress: 'Locking process',
      takeActivity: 'Detail',
      contactUS: 'Contact Us',
      FQA: 'FAQ',
      income: 'Financial income',
    },
    detail: {
      activityProgress: 'Process',
      lockAllNum: 'Total locking amount',
      lockNum: 'Locked Quantity',
      lockMinNum: 'Minimum quantity per lock ',
      lockMaxNum: 'Maximum cumulative lock quantity',
      userLocked: 'Locked  quantity',
      twoDayIncome: [
        'Days',
        'Prospective earnings：',
      ],
      totalGainAmount: 'Cumulative grantings',
      totalUserGainAmount: 'Earned',
      rulesDangers: 'I am fully aware of the project risks',
      agreePOS: 'Agree to PoS',
      activityStatus: [
        'Locking starts at',
        'Locking ends at',
        'Interest starts at',
        'Interest ends at',
        'Principal release',
      ],
      incomeTime: 'Time on earnings received',
      incomeNum: 'Quantity on earnings received',
      incomeDetail: 'Details on earnings received',
      balanceError: [
        'The locking quantity should be less than the quantityof ',
        ' in your account',
      ],
      buyAmountMinError: [
        'Minimum quantity per lock',
      ],
      buyAmountMaxError: [
        'Maximum cumulative lock quantity',
      ],
      buySuccess: 'Purchase succeeded',
    },
    myPos: {
      lockPosTable: [
        'Coin',
        'Locking starts at',
        'Locked Quantity',
        'Estimated annual interest rate',
        'Current locked earnings',
        'PoS status',
      ],
      unLockPosTable: [
        'Coin',
        'Date on earnings received',
        'Principal',
        'Annual interest rate',
        'Quantity of receiving earnings',
      ],
      lockPOS: 'PoS locked',
      havePOS: 'PoS position',
      endTime: 'Deadline',
    },
  },
  singPassLogin: {
    mainText1: 'Other login methods',
    mainText2: 'SingPass, a third-party login',
    mainText3: 'The QR code is invalid',
    mainText4: 'Please click refresh',
    mainText5: 'Open',
    mainText6: 'Moblie phone SingPass',
    mainText7: 'Scan code to login',
    mainText8: 'No SingPass App yet?',
    mainText9: 'Download now',
    mainText10: 'You have not linked your exchange account yet. Please choose a linking method.',
    mainText11: 'Link with a new account',
    mainText12: 'Link with current account',
    mainText13: 'Log in and link your SingPass account',
    mainText14: 'Register and link your SingPass account',
    mainText15: 'SingPass, a third-party Register',
  },
  registerOptions: {
    title: 'Safety reminder',
    text: 'Due to the unstable network of the operator, SMS reception may be delayed in your current region. It is recommended that you use Google authentication',
    conf: 'Bind Google',
    close: 'Still bound to phone',
  },
  futures: {
    currentSymbol: {
      title1: 'Mark Price',
      title2: 'Index Price',
      title3: 'Funding Rate',
      title4: 'Estimated Rate',
      title5: '24H Volume',
      explain1: 'Mark price is used to calculate PNL and liquidation.<br /> Mark price may offset from the latest market price, in case of market manipulation',
      explain2: 'Underlying fair value in spot market.',
      explain3: 'The funding rate will be settled based on this value at the end of the current period',
      explain4: 'Funding fees are settled every 8 hours (for position holders only) at 00:00, 08:00 and 16:00 UTC respectively. <br />Funding fee = real-time funding rate at settlement point * position value <br />Position value = number of position cont * par value * marker price',
      explain5: 'The next settlement funding rate is expected to be calculated based on this value.',
      explain6: 'If the funding rate is positive, longs pay shorts. If the funding rate is negative, shorts pay longs.',
      marginModel1: 'Cross',
      marginModel2: 'Isolated',
    },
    depth: {
      text1: 'Order Book',
      text2: 'Last trades',
      text3: 'Index',
      text4: 'Depth',
      text5: 'Mark',
      theadList1: 'Price',
      theadList2: 'Amount',
      theadList3: 'Sum',
    },
    market: {
      text1: 'Futures',
      text2: 'Last Price',
      text3: 'Change',
      text4: 'USDT-M Futures',
      text5: 'Coin-M Futures',
      text6: 'Mixed-M Futures',
      text7: 'Demo',
      text8: 'Search',
    },
    newTrade: {
      text1: 'Last trades',
      text2: 'Price',
      text3: 'Amount',
      text4: 'Time',
    },
    orderList: {
      tabType1: 'Positions',
      tabType2: 'Open Orders',
      tabType3: 'Trigger Order',
      tabType4: 'Order History',
      tabType5: 'Transaction History',
      subTabType1: 'All',
      subTabType2: 'TP Order',
      subTabType3: 'SL Order',
      a_columns_1: 'Symbol',
      a_columns_2: 'Side',
      a_columns_3: 'Amount',
      a_columns_4: 'Filled Rate',
      a_columns_5: 'Order Price',
      a_columns_6: 'Average Price',
      a_columns_7: 'Type',
      a_columns_8: 'Reduce-only',
      a_columns_9: 'Time',
      a_columns_10: 'Operation',
      b_columns_1: 'Symbol',
      b_columns_2: 'Side',
      b_columns_3: 'Trigger Price',
      b_columns_4: 'Order Price',
      b_columns_5: 'Amount/Value',
      b_columns_6: 'Type',
      b_columns_7: 'Reduce-only',
      b_columns_8: 'Place Time',
      b_columns_9: 'Expiration Time',
      c_columns_1: 'Symbol',
      c_columns_2: 'Type',
      c_columns_3: 'Side',
      c_columns_4: 'Order Price',
      c_columns_5: 'Amount/Value',
      c_columns_6: 'Order amount',
      c_columns_7: 'Average Price',
      c_columns_8: 'P/L',
      c_columns_9: 'Status',
      c_columns_10: 'Time',
      c_columns_11: 'Trading fee',
      d_columns_1: 'Time',
      d_columns_2: 'Type',
      d_columns_3: 'Amount',
      d_columns_4: 'Coin',
      typeStatus1: 'Limit Order',
      typeStatus2: 'Market Order',
      typeStatus3: 'Post Only',
      typeStatus4: 'liq',
      typeStatus5: 'Merge positions',
      getStatus1: 'New Order',
      getStatus2: 'Full-filled',
      getStatus3: 'Partial-filled',
      getStatus4: 'Cancelled',
      getStatus5: 'Cancelling',
      getStatus6: 'Abnormal',
      getStatus7: 'Partial-filled and Cancelled',
      sideT1: 'Open',
      sideT2: 'Close',
      sideT3: ' Short',
      sideT4: ' Long',
      mPrice: 'Market Price',
      isclose1: 'Yes',
      isclose2: 'No',
      cancel: 'Cancel',
      allCancel: 'Cancel All',
      close_all_position: 'Close All',
      close_all_tip: 'Closing all positions cancels all open orders under USDT-M and close all positions under USDT-M by market order.Are you sure you want to close all positions?',
      tstext1: 'Please',
      tstext2: 'Login/Register',
      tstext3: 'to operation',
      memoText1: 'Cancelled by user',
      memoText2: 'The order was canceled by the system because of an exception',
      memoText3: 'Liquidated，unfilled order is cancelled by system',
      memoText4: 'Insufficient opponents, the order was cancelled by the system',
      memoText5: 'FOK Order, fully filled or cancelled by system',
      memoText6: 'IOC order，filled immediately or cancelled by system',
      memoText7: 'Post only, Taker order will be cancelled by system',
      memoText8: 'The order has been cancelled because the position no longer exists',
      newText1: 'PNL records',
      newText2: 'Trading Record',
      newText3: 'Open price',
      newText4: 'Average Close Price',
      newText5: 'Number of Positions',
      newText6: 'Realized profits and losses',
      newText7: 'The total PNL (Profit and Loss) represents the total profit and loss accumulated during the holding period of the position. The total PNL = trading fees+ funding fees+ position profit and loss + Loss sharing',
      newText8: 'Cumulative total handling fee for opening and closing positions',
      newText9: 'Funding Fee',
      newText10: 'Total funding costs during the holding period',
      newText11: 'The position profit and loss is the sum of the position profit and loss for each time the position is closed, ',
      newText12: 'Loss sharing',
      newText13: 'Close Time',
      newText14: ' role',
      newText15: 'Position profit and loss',
      newText16: 'Only the current contract',

    },
    tradeForm: {
      mPrice: 'Market',
      textjz: 'Value',
      text1: 'Place Order',
      text2: 'Available',
      text3: 'The available balance is the fund that the user can freely dispose of.<br />Available balance is used as cross margin first, when loss happens, availalble balance will decrease accordingly',
      text4: 'Term of Validity',
      text5: 'Cost',
      text6: 'R/O',
      text7: 'A "Reduce Only" order will only reduce your position, and will not increase it',
      text8: 'Price',
      text9: 'Amount',
      text10: 'Cont.',
      text11: 'Price',
      text12: 'Trigger Price',
      text13: 'When the latest traded price of the contract reaches the price you set, the system will place an order for you according to the order price and quantity you set.',
      text14: 'Open Value',
      text15: 'Open position value，O/V = Amount * Price.<br />Actual dealed amount is related to deal price',
      text16: '24 Hour',
      text17: '7 Day',
      text18: '14 Day',
      text19: '30 Day',
      text20: 'Open',
      text21: 'Close',
      text22: 'Limit Order',
      text23: 'Market Order',
      text24: 'Trigger Order',
      text25: 'Available',
      text26: 'Available',
      text27: 'Max Buy',
      text28: 'Max Sell',
      text29: 'P/O',
      text30: 'The "Post-Only" option ensures that the user only acts as a maker and the order will not be immediately matched in the market. If this order would be immediately matched with an existing order, the order will be immediately canceled.',
      text31: 'IOC (Immediately or Cancel) orders will be immediately cancelled for any unfilled portion if it cannot be filled immediately.',
      text32: 'FOK (Fill or Kill) order will be immediately canceled if it cannot be filled all.',
      text33: 'Open futures trading',
      text34: 'Login to trade',
      text35: 'Close Short',
      text36: 'Close Long',
      text37: 'Open Long',
      text38: 'Open Short',
      text39: 'Buy Long',
      text40: 'Sell Short',
      text41: 'Too much price deviation',
      text42: 'Exceed single order amount limit, max amount ',
      text43: 'Below single order amount limit, min amount ',
      text44: 'Exceed single order volume limit, max volume ',
      text45: 'Below single order volume limit, min volume ',
      text46: 'Exceed close available!',
      text47: 'Price',
      text48: 'Amount',
      text49: 'Open Value',
      text50: 'Trigger Price',
      text51: 'Insufficient Margin',
      text52: 'Market Price',
      text53: 'Amount',
      text54: 'Can not change when orders exist',
      text55: 'There are currently entrusted/positions in this contract, and position types cannot be adjusted',
      text56: 'Exceeded maximum order amount, you can order up to',
      text57: 'Beyond the maximum order amount',
      text58: 'Price below the minimum limit',
      text59: 'Price above the maximum limit',
    },
    calculator: {
      text1: 'Calculator',
      text2: 'Leverage Level',
      text3: 'The maximum position size available at current leverage is',
      text4: 'Calculate',
      text5: 'Result',
      text6: 'Initial Margin',
      text7: 'PnL',
      text8: 'ROE',
      text9: 'Close Price',
      text10: 'Can not reach this return rate',
      text11: 'Liq.price',
      text12: 'Open Price',
      text13: 'Close Price',
      text14: 'Amount',
      text15: 'Cont',
      text16: 'PnL',
      text17: 'Long',
      text18: 'Short',
      text19: 'Open Long',
      text20: 'Open Short',
      text21: 'Amount',
      text22: 'Initial Margin',
      text23: 'Insufficient Balance',
      text24: 'will not be liquidated',
      text25: 'The calculation result is for reference only. Actual operation may result in deviations due to transaction fees and funding rates',
      text26: 'Cross',
      text27: 'Isolated',
      text28: 'Available balance insufficient for minimum margin',
      text29: 'Available',
      text30: 'Increase Margin',
    },
    depositMode: {
      text1: 'Cross mode: All positions use the whole cross account balance to avoid to be liquidated.<br />If liquidation happens,cross positions and  cross balance will be lost.',
      text2: 'Isolated mode:Some balance is allocated to the isolated account.<br />When isolated balance is below maintenance margin, the isolated positions will be liquidated.<br />In this mode, Margin balance can be increased or decreased.',
      text3: 'Switch to Cross Mode',
      text4: 'Switch to Isolated Mode',
      text5: 'Please log in before proceeding with the operation',
      text6: 'Cross Mode',
      text7: 'Isolated Mode',
      text8: 'Can not change,when positions or orders exist',
      text9: 'Cross',
      text10: 'Isolated',
      text12: ' Margin Mode',
      tradingMode: 'Trading Mode',
      merge: 'Merge',
      split: 'Split',
      position_mode: 'Position mode',
      merge_mode: 'Merge Mode: Orders placed in the same direction (long or short) and for the same trading pair will be combined into a single position. There can only be two positions (long or short) for the same trading pair. The leverage for all positions in the same trading pair can only be adjusted uniformly in the order area. After adjustment, the position will be displayed according to the latest leverage multiplier.',
      split_mode: 'Split Mode: Multiple positions can be opened in the same direction (long or short) and for the same trading pair. Orders placed in isolated mode will not be merged with existing positions. Multiple positions (long or short) can be held for the same trading pair. Each position can have its own independent leverage multiplier, and the leverage multiplier in the order area only affects newly opened positions.',
    },
    reminder: {
      text1: 'Trigger Price',
      text2: 'Price',
      text3: 'Do not remind again, you can reset it in [Preferences].',
      text4: 'Amount',
      text5: 'Volume',
      text6: 'Margin Used',
      text7: 'Order Margin',
      text8: 'Limit Order',
      text9: 'Market Order',
      text10: 'Trigger Order',
    },
    lever: {
      text1: 'Leverage Level',
      text2: 'Maximum level in current position',
      text3: 'The maximum position size available at current leverage is',
      text4: 'Confirm',
      text5: 'Please log in before proceeding with the operation',
      text6: 'Can not change when orders exist',
      text7: 'Contract Leverage Level',
      text8: 'Min level can not be below',
    },
    openFutures: {
      titleText: 'Contract Activation Reminder',
      openTips: 'Dear user, you have not yet activated perpetual contracts, which allows you to engage in related operations',
      confirmText: 'Activate the contract',
      cancelText: 'Not activating the contract for now',
      agreeText: 'I have understood the risks involved in the contract and agreed to the',
      agreeLink: 'Perpetual Contract Service Agreement',
      question1: '1.What is the maximum profit and loss ratio you may face in this trading activity？',
      answer1_1: 'Unlimited profit and loss',
      answer1_2: 'Less than 50%',
      question2: '2.Who will bear the responsibility if you suffer partial or even total loss of funds during trading?',
      answer2_1: 'You will bear the responsibility alone, as this is a rational choice made by you alone',
      answer2_2: 'The platform will bear the responsibility',
      protocolLink: 'https://exchange.zendesk.com/hc/en-us/articles',
    },
    positionLis: {
      columns1: 'Symbol',
      columns2: 'Total/Avbl',
      columns3: 'Entry Price',
      columns4: 'Mark Price',
      columns5: 'Liq. Price',
      columns6: 'Margin',
      columns7: 'Margin Rate',
      columns8: 'PNL/ROI',
      columns9: 'Operation',
      columns10: 'TP/SL',
      textQuickClosing: 'Quick Close',
      text1: 'Price',
      text2: 'Limit Close',
      text3: 'Market Close',
      text4: 'Amount',
      text5: 'Cont',
      text6: 'Total:Total amount held in this contract.<br />Available:Amount is available to close.<br /> Positive means long, negative means short.',
      text7: 'Average open price',
      text8: 'Mark price is used to calculate PNL and liquidation.<br />Mark price may offset from the latest market price, in case of market manipulation',
      text9: ' When mark price is close to liquidation price, position will be liquidated',
      text10: 'Used for collateralizing this position. Isolated Margin is the actual collateralizing assets for this position. Cross Margin is the required collateralizing assets for the current leverage.',
      text11: 'The margin ratio is used to determine the risk of liquidation of the position. When the margin ratio is less than or equal to 100%, the corresponding position will be forcibly liquidated.',
      text12: 'Unrealized P&L refers to the floating profit or loss of an open position, calculated from the opening price to the current price. For long positions, it is calculated as (Mark Price - Average Entry Price) * Quantity, and for short positions, it is calculated as (Average Entry Price - Mark Price) * Quantity.<br />Return on investment (ROI) refers to the average rate of return on the margin used, and is calculated as profit and loss divided by margin used. ',
      text13: 'TP/SL orders mean: Set trigger conditions in advance.<br />When orders trigged, orders place.<br />TP/SL help to preserve profit or cut down loss.',
      text14: 'Cross',
      text15: 'Isolated',
      text16: 'Short',
      text17: 'Long',
      text18: 'Please input order price',
      text19: 'Please input order amount',
      text20: 'Exceed the close available',
      text21: 'Close Long',
      text22: 'Close Short',
      text23: 'Market Price',
      text24: 'Amount',
      text25: 'Cont.',
      text26: 'Realized P&L',
      text27: 'Realized profit and loss is the income that has been settled into the user s balance,including transaction fees, capital costs, liquidation profit and loss, settlement income, etc.',
      text28: 'Fees',
      text29: 'Realized profits and losses',
      text30: 'Funding Fee',
      text31: 'Position settlement',
      text32: 'Loss sharing',
    },
    setFutures: {
      titleText: 'Preferences',
      text1: 'Position Mode',
      text2: 'Can not change when any position or order exists',
      text3: 'Netting Mode',
      text4: 'Only buy or sell side position exists in netting mode',
      text5: 'Hedging Mode',
      text6: 'Both buy and sell side position can exist in hedging mode',
      text7: 'Confirm before place order',
      text8: 'Enable',
      text9: 'Disable',
      text10: 'Contract unit',
      text11: 'Cont.',
      text12: 'Confirm',
      text13: 'Validity period of conditional orders/take profit and stop loss orders.',
      text14: 'Confirm before place order',
    },
    setMarginCoin: {
      titleText: 'Modify Isolated Margin Balance',
      text1: 'Current',
      text2: 'After',
      text3: 'Amount',
      text4: 'Margin Balance',
      text5: 'Actual Leverage Level',
      text6: 'Liquidation Price',
      text7: 'Available',
      text8: 'Available',
      text9: 'Total',
      text10: 'Increase',
      text11: 'Decrease',
      text12: 'Increase Margin Balance',
      text13: 'Decrease Margin Balance',
      text14: 'Insufficient balance to increase',
      text15: 'Insufficient balance to decrease',
    },
    stopOrder: {
      titleText: 'TP/SL',
      text1: 'Take Profit',
      text2: 'Cancel all TP orders',
      text3: 'TP Trigger/Order Price > Mark Price',
      text4: 'TP Trigger/Order Price  < Mark Price',
      text5: 'Estimated PNL',
      text6: 'Estimated ROI',
      text7: 'Stop Loss',
      text8: 'Cancel all SL orders',
      text9: 'Liquidation Price < SL Trigger/Order Price < Mark Price',
      text10: 'Mark Price < SL Trigger/Order Price < Liquidation Price',
      text11: 'Estimated PNL',
      text12: 'Estimated ROI',
      text13: 'Trigger Price',
      text14: 'Order Price',
      text15: 'Order Amount',
      text16: 'Cont.',
      text17: 'Trigger Price',
      text18: 'Order Price',
      text19: 'Please input order amount',
      text20: 'Price',
      text21: 'TP price must be above mark price！',
      text22: 'TP price must be below mark price！',
      text23: 'SL price must be below mark price！',
      text24: 'SL price must be above liquidation price！',
      text25: 'SL price must be above mark price！',
      text26: 'SL price must be below liquidation price！',
      text27: 'Too large price deviation！',
      text28: 'Exceed close volume available！',
      text29: 'Term of validity',
      text30: 'Market',
      columns1: 'Futures',
      columns2: 'Total/Available',
      columns3: 'Cost',
      columns4: 'Mark Price',
      columns5: 'Liquidation Price',
      columns6: 'TP Trigger',
      columns7: 'Order Price ',
      columns8: 'Order Amount',
      columns9: 'SL Trigger',
      columns10: 'Latest Price',
      time1: '24H',
      time2: '7 Day',
      time3: '14 Day',
      time4: '30 Day',
    },
    order: {
      startTime: 'Start',
      endTime: 'End',
      coType: 'Type',
      coSide: 'Side',
      contract: 'Symbol',
      orderType: 'Type',
      cancelAll: 'Cancel All Orders',
      title1: 'Current Order',
      title2: 'Stop Order',
      title3: 'Limit Order History',
      title4: 'Trigger Order History',
      title5: 'Trade History',
      typeList1: 'Perpetual Futures',
      typeList2: 'Demo',
      typeList3: 'Mixed Futures',
      sideType1: 'USDT-M Futures',
      sideType2: 'Coin-M Fututres',
      all: 'Total',
      orderType1: 'Limit Order',
      orderType2: 'Market Order',
      orderType3: 'Post Only',
      orderType4: 'IOC',
      orderType5: 'FOK',
      orderType6: 'liq',
      orderType7: 'Merge positions',
      time: 'Time',
      side: 'Side',
      intrustPrice: 'Order Price',
      intrustVolume: 'Order Amount(Cont.)',
      dealVolume: 'Filled Amount(Cont.)',
      dealPrice: 'Average Price',
      priceDeal: 'Filled price',
      onlyCut: 'Reduce Only',
      opera: 'Operation',
      triggerPrice: 'Trigger Price',
      intrustVolumeOrNum: 'Order Amount/Value',
      overTime: 'Expiration Time',
      status: 'Status',
      submitTime: 'Place time',
      triggerTime: 'Triggered Time',
      roles: 'Role',
      fee: 'Commission',
      status1: 'New Order',
      status2: 'Full-filled',
      status3: 'Partial-filled',
      status4: 'Cancelled',
      status5: 'Cancelling',
      status6: 'Abnormal',
      status7: 'Partial-filled and Cancelled',
      contractType1: 'Perpetual',
      contractType2: 'This week',
      contractType3: 'Next week',
      contractType4: 'Monthly',
      contractType5: 'Quarterly',
      statusText1: 'Valid',
      statusText2: 'Canceled',
      statusText3: 'Finished',
      statusText4: 'Order Failed',
      open: 'Open',
      close: 'Close',
      buy: 'Long',
      sell: 'Short',
      currentPrice: 'Market Price',
      yes: 'Yes',
      no: 'No',
      per: 'Cont.',
      cancel: 'Cancel',
      memoText1: 'Cancelled by user',
      memoText2: 'Over the period of validity',
      memoText3: ' has reached',
      memoText4: ' trigger price, but the entrustment cannot be submitted due to insufficient margin, and the execution fails',
      memoText5: 'trigger price, but the entrustment cannot be submitted due to insufficient margin, and the execution fails',
      memoText6: ' trigger price, the execution fails due to position forced liquidation.',
      memoText7: ' trigger price, the assignment cannot be submitted as the tradingoperation is suspended,execution fails',
    },
    coFlowingWater: {
      startTime: 'Start',
      endTime: 'End',
      coin: 'Coin',
      type: 'Type ',
      all: 'Total',
      transferIn: 'Deposit',
      transferOut: 'Withdrawal',
      fee: 'Funding Fee',
      loss: 'Loss sharing',
      time: 'Time',
      amount: 'Amount',
      typeList1: 'Handling fee sharing',
      typeList2: 'Bonuses',
      typeList3: 'Bonus recycling',
      typeList4: 'Closing fee',
      typeList5: 'Open warehouse fee',

    },
    coAccount: {
      coAccount: 'Contract Account',
      transfer: 'Transfer',
      coin: 'Coin',
      canUser: 'Available',
      allBalance: 'Total Balance',
      allMargin: 'Cross Balance',
      subMargin: 'Isolated Balance',
      lockMargin: 'Frozen Balance',
      opera: 'Operation',
    },
    transfer: {
      transfer: 'Transfer',
      from: 'From',
      to: 'To',
      coin: 'Coin',
      volume: 'Quantity',
      volumeError: 'Insufficient Quantity',
      all: 'Total',
      canTransfer: 'Available',
      confirm: 'Confirm',
      cantIn: 'Deposit Restricted',
      cantOut: 'Withdrawal Restricted',
      exchangeAccount: 'Spot Account',
      coAccount: 'Futures Account',
      noBonus: 'Bonus is not include',
      bonusNote: 'The trading bonus cannot be withdrawn directly, but the profitable part could.The trading bonus can be used for opening positions, paying trading fees, funding fee and the settlement for closing positions. The trading bonus will be deducted at the end for paying fee or position loss.',
    },
    assets: {
      text1: 'Assets',
      text2: 'Information',
      text3: 'Transfer',
      text4: 'More',
      text5: 'Account MR',
      // text6: 'AMR = Total Balance / Open Positions Value.<br />This value is used to gauge the account risk approximately.<br />Margin rate goes smaller, the liquidation risk goes bigger',
      text6: 'AMR = Total Balance / Total margin used. <br />This value is used to indicate the approximate situation of secured assets. <br />The lower the margin ratio, the greater the risk of forced liquidation or position reduction.',
      text7: 'Total assets',
      text8: 'Total equity of this margin coin.<br />Total Balance = Cross Balance + Isolated Balance + Frozen Balance',
      text9: 'Cross Balance',
      text10: 'Cross Balance. When cross is liquidated, the balance will be lost.<br />Notice: Balance transfered to contract account will be as Cross Balance automatically',
      text11: 'Isolated Balance',
      text12: 'Isolated Balance. Separated from cross account or other isolated account.<br />When liquidations occur, balance in cross and isolated accounts  are without interference',
      text13: 'Frozen Balance',
      text14: 'Total frozen balance of unfilled limit orders',
      text15: 'Symbol',
      text16: 'Delivery Date',
      text17: 'Contract Underlying',
      text18: 'Index',
      text19: 'Margin Coin',
      text20: 'Single Contract value',
      text21: 'Tick',
      text22: 'Min MMR',
      text23: 'Settlement cycle',
      text24: [
        'Perpetual',
        'Weekly',
        'Bi-Weekly',
        'Monthly',
        'Quarterly',
      ],
      text25: 'Contract Data',
    },
    assetsChart: {
      text1: 'Isolated',
      text2: 'Cross',
      text3: 'Frozen',
    },
  },
  futuresData: {
    navTitle: 'Contract Data',
    typeTabList1: 'USDT-M Futures',
    typeTabList2: 'Coin-M Futures',
    typeTabList3: 'Mixed-M Futures',
    typeTabList4: 'Demo Futures',
    promptText1: 'Coins',
    promptText2: 'Type',
    promptText3: 'Futures',
    tabList1: 'Insurance Fund',
    tabList2: 'Funding Rate',
    tabList3: 'Index Price',
    tabList4: 'Mark Price',
    columns1: 'Time',
    columns2: 'Type',
    columns3: 'Amount',
    columns4: 'Futures',
    columns5: 'Funding Rate',
    columns6: 'Exchange',
    columns7: 'Weight',
    tbaleTitle1: 'Activities',
    tbaleTitle2: 'Historical Data',
    tbaleTitle3: 'The composition of the index price',
    moreText1: 'Learn more about insurance fund',
    moreText2: 'Learn more about funding rate',
    moreText3: 'Learn more about index price',
    moreText4: 'Learn more about mark price',
    text1: 'The insurance fund balance of {USDT} margined perpetual',
    text2: 'Liquidation deposit',
    text3: 'Amortizatoin withdrawal',
  },
  creditCard: {
    title: 'Credit Card',
    amount: 'Purchase quantity',
    num: 'Purchase Amount(Excluding service charge)',
    buy: 'Buy',
    mark: 'MoonPay makes buying cryptocurrencies simpler, faster and safer for everyone. It accepts all major debit / credit cards and new mobile payment methods like Apple Pay.',
    warnTit: 'Please Note',
    warn1: '1.The crypto amount quoted is based on the current rate and is not final. If the rate changes by more than +/-2.5% you will be asked to reconfirm the transaction via email from MoonPay',
    warn2: 'Once payment is completed, you can check your $<payment status>$ on MoonPay or $<Payment Overview>$ on Exchange',
    warn3: '3.If you have any questions, please contact MoonPay customer support. (support@moonpay.io)',
    confirmTit: 'Go to MoonPay to pay',
    confirmBtn: 'Leaving Exchange to MoonPay',
    confirmText1: 'MoonPay will transfer the crypto to your Spot account in 2 ~ 10 mins, after MoonPay payment is completed .',
    confirmText2: 'You are aware that MoonPay is a fiat-to-crypto exchange platform operated independently by a third party. Our exchange shall not be held responsible for any loss or damage incurred through the use of their services.',
    callBackTit: 'MoonPay Payment feedback',
    callBackTrue: 'Trade',
    callBackFalse: 'View assets',
    callBackText1: '1.When the payment is complete, you will receive an email from MoonPay. You can check the $<payment status>$ in MoonPay',
    callBackText2: '2.Once payment is completed, MoonPay will deposit the funds into your spot account via a recharge method.',
    callBackText3: '3.If you have any questions, please contact MoonPay customer support. (support@moonpay.io)',
  },
};
